import { SVGProps, useId } from "react";

export const LocationPinIcon = ({ size = 48 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24 2C16.268 2 10 8.268 10 16c0 10.5 14 28 14 28s14-17.5 14-28c0-7.732-6.268-14-14-14z"
      fill="#EF4444"
    />
    <circle cx="24" cy="16" r="6" fill="white" />
    <ellipse cx="24" cy="45" rx="8" ry="2" fill="#EF4444" opacity="0.3" />
  </svg>
);

export const BackArrowIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 12H5M5 12L12 19M5 12L12 5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ChevronRightIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 18L15 12L9 6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SearchIcon = ({
  width = 24,
  height = 24,
  fillColor = "white",
}: {
  width?: number;
  height?: number;
  fillColor?: "white" | "stg-grey-4";
}) => {
  const _fillColor = fillColor === "stg-grey-4" ? "#B6B6B6" : "white";
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z"
        stroke={_fillColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.0004 20.9999L16.6504 16.6499"
        stroke={_fillColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PlayIcon = ({ color = "black" }: { color?: string }) => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.72453 3.96704C4.74704 3.77782 4.81337 3.59646 4.91827 3.43738C5.02316 3.2783 5.16372 3.14589 5.32877 3.05066C5.49382 2.95543 5.6788 2.90002 5.86903 2.88883C6.05925 2.87764 6.24946 2.91098 6.42453 2.98621C7.30953 3.36454 9.29286 4.26371 11.8095 5.71621C14.327 7.16954 16.0979 8.43871 16.867 9.01454C17.5237 9.50704 17.5254 10.4837 16.8679 10.9779C16.1062 11.5504 14.357 12.8029 11.8095 14.2745C9.25953 15.7462 7.29953 16.6345 6.42286 17.0079C5.66786 17.3304 4.82286 16.8412 4.72453 16.027C4.60953 15.0754 4.39453 12.9145 4.39453 9.99621C4.39453 7.07954 4.6087 4.91954 4.72453 3.96704Z"
        fill={color}
      />
    </svg>
  );
};

export const PlatterVolumeHighIcon = ({
  className,
}: {
  className?: string;
}) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M12 3V21C8.5 21 5.8995 16.42 5.8995 16.42H3C2.73478 16.42 2.48043 16.3146 2.29289 16.1271C2.10536 15.9396 2 15.6852 2 15.42V8.505C2 8.23978 2.10536 7.98543 2.29289 7.79789C2.48043 7.61036 2.73478 7.505 3 7.505H5.8995C5.8995 7.505 8.5 3 12 3Z"
      fill="currentColor"
    />
    <path
      d="M15.7615 8.09299C15.8229 8.0156 15.8989 7.95109 15.9852 7.90316C16.0716 7.85522 16.1665 7.82481 16.2646 7.81366C16.3627 7.80251 16.4621 7.81084 16.557 7.83819C16.6519 7.86553 16.7404 7.91134 16.8175 7.97299L16.819 7.97449L16.822 7.97749L16.831 7.98349L16.8535 8.00299L16.921 8.06299C16.978 8.11299 17.049 8.18399 17.134 8.27599C17.305 8.46049 17.524 8.72899 17.7415 9.08599C18.1795 9.80599 18.6025 10.8755 18.6025 12.308C18.6025 13.739 18.1795 14.81 17.743 15.53C17.5149 15.9059 17.2391 16.2508 16.9225 16.556L16.8325 16.6355L16.819 16.646C16.819 16.646 16.1485 17.0105 15.7645 16.529C15.6411 16.3745 15.5836 16.1775 15.6047 15.9808C15.6257 15.7842 15.7236 15.6038 15.877 15.479L15.8785 15.476V15.4775L15.88 15.476L15.907 15.452C15.935 15.427 15.977 15.3845 16.033 15.3245C16.1455 15.2045 16.3015 15.0125 16.459 14.7515C16.774 14.234 17.1025 13.4285 17.1025 12.3065C17.1025 11.1845 16.774 10.382 16.4605 9.86599C16.3056 9.61148 16.1197 9.37719 15.907 9.16849L15.88 9.14449C15.7251 9.0207 15.6269 8.84057 15.6044 8.64351C15.582 8.44645 15.6384 8.2485 15.7615 8.09299ZM18.316 4.97299C18.2393 4.90944 18.1506 4.86184 18.0552 4.83296C17.9598 4.80408 17.8596 4.7945 17.7605 4.80479C17.6613 4.81507 17.5652 4.84501 17.4778 4.89286C17.3904 4.9407 17.3134 5.0055 17.2513 5.08345C17.1892 5.1614 17.1432 5.25095 17.1161 5.34687C17.089 5.44278 17.0813 5.54313 17.0934 5.64206C17.1056 5.74098 17.1373 5.8365 17.1868 5.92302C17.2362 6.00955 17.3024 6.08535 17.3815 6.14599L17.398 6.16099L17.476 6.22849C17.545 6.29149 17.65 6.38899 17.776 6.52099C18.031 6.78649 18.376 7.18549 18.7225 7.71199C19.4125 8.76349 20.101 10.3115 20.101 12.3155C20.1078 13.9506 19.6285 15.5508 18.724 16.913C18.379 17.438 18.034 17.834 17.779 18.098C17.6578 18.2234 17.5312 18.3436 17.3995 18.458L17.3815 18.473C17.2302 18.5983 17.134 18.7779 17.1137 18.9734C17.0934 19.1688 17.1507 19.3644 17.2731 19.5181C17.3956 19.6718 17.5734 19.7713 17.7684 19.7952C17.9635 19.8191 18.1601 19.7655 18.316 19.646L18.364 19.6055L18.478 19.508C18.575 19.423 18.7015 19.3005 18.8575 19.1405C19.2736 18.7085 19.6482 18.2384 19.9765 17.7365C21.0421 16.1298 21.6074 14.2434 21.601 12.3155C21.605 10.3861 21.0399 8.49838 19.9765 6.88849C19.6477 6.38603 19.2731 5.91503 18.8575 5.48149C18.7007 5.31865 18.5365 5.16299 18.3655 5.01499L18.3325 4.98649L18.322 4.97749L18.3175 4.97449L18.316 4.97299Z"
      fill="currentColor"
    />
  </svg>
);

export const PlatterMutedIcon = ({ className }: { className?: string }) => {
  const maskId = useId();

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <mask
        id={maskId}
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="15"
        y="9"
        width="7"
        height="7"
      >
        <path d="M15 9H21.5V15.5H15V9Z" fill="white" />
      </mask>
      <g mask={`url(#${maskId})`}>
        <path
          d="M20.368 10.1426L16.125 14.3851M16.1255 10.1426L20.368 14.3851"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        d="M12 3V21C8.5 21 5.8995 16.42 5.8995 16.42H3C2.73478 16.42 2.48043 16.3146 2.29289 16.1271C2.10536 15.9396 2 15.6852 2 15.42V8.505C2 8.23978 2.10536 7.98543 2.29289 7.79789C2.48043 7.61036 2.73478 7.505 3 7.505H5.8995C5.8995 7.505 8.5 3 12 3Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const CircularPlayIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="42"
      height="42"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x={0.25}
        y={0.25}
        width={59.5}
        height={59.5}
        rx={29.75}
        fill="#000"
        fillOpacity={0.7}
      />{" "}
      <rect
        x={0.25}
        y={0.25}
        width={59.5}
        height={59.5}
        rx={29.75}
        stroke="#fff"
        strokeWidth={0.5}
      />
      <path
        d="M43.462 30.159a1 1 0 0 1-.03 1.73L22.598 43.492a1 1 0 0 1-1.487-.874V18.44a1 1 0 0 1 1.517-.857z"
        fill="#fff"
      />
    </svg>
  );
};
export const CircularPlayIconWithoutBg = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1.5"
        y="1.5"
        width="29"
        height="29"
        rx="14.5"
        stroke="white"
        strokeWidth="3"
      />
      <path
        d="M22.5423 15.4994C23.0932 15.9088 23.0775 16.7388 22.5113 17.1269L13.5655 23.2601C12.9019 23.715 12 23.2399 12 22.4353L12 9.65545C12 8.83348 12.9366 8.36254 13.5964 8.85276L22.5423 15.4994Z"
        fill="white"
      />
    </svg>
  );
};
export const BackIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      width="17"
      height="15"
      viewBox="0 0 17 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.358 6.59277H3.2117L7.40636 2.36694C7.77384 1.99697 7.77384 1.39682 7.40636 1.02691C7.03888 0.656721 6.44311 0.656721 6.07618 1.02691L0.275609 6.8703C-0.0918698 7.24026 -0.0918698 7.84047 0.275609 8.21033L6.07618 14.054C6.25986 14.2391 6.50059 14.3316 6.74127 14.3316C6.98194 14.3316 7.22267 14.2391 7.40636 14.054C7.77384 13.684 7.77384 13.0839 7.40636 12.714L3.2117 8.48797H15.358C15.8775 8.48797 16.2988 8.06366 16.2988 7.54034C16.2988 7.01702 15.8776 6.59277 15.358 6.59277Z"
        fill="white"
      />
    </svg>
  );
};

export const Forward = () => {
  return (
    <svg
      width="8"
      height="13"
      viewBox="0 0 8 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 10.9123L4.48254 6.32227L0 1.73227L1.38 0.322266L7.25232 6.32227L1.38 12.3223L0 10.9123Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const CreditCardIcon = () => (
  <svg
    width="18"
    height="14"
    viewBox="0 0 18 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" y="0.5" width="17" height="13" rx="2" stroke="white" />
    <rect x="0" y="3" width="18" height="3" fill="white" />
  </svg>
);

export const CheckmarkCircleIcon = ({
  size = 12,
  className,
}: {
  size?: number;
  className?: string;
}) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
  >
    <circle cx="6" cy="6" r="6" fill="white" />
    <path
      d="M5.05347 8.38966C4.92014 8.38966 4.79347 8.33633 4.70014 8.24299L2.81347 6.35633C2.62014 6.16299 2.62014 5.84299 2.81347 5.64966C3.00681 5.45633 3.32681 5.45633 3.52014 5.64966L5.05347 7.183L8.48014 3.75633C8.67347 3.56299 8.99347 3.56299 9.18681 3.75633C9.38014 3.94966 9.38014 4.26966 9.18681 4.46299L5.40681 8.24299C5.31347 8.33633 5.18681 8.38966 5.05347 8.38966Z"
      fill="#258D58"
    />
  </svg>
);

export const CloseIcon = ({
  width = 17,
  height = 17,
  color = "white",
}: {
  width?: number;
  height?: number;
  color?: string;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.83101 8.46216L15.7949 2.49804C16.1831 2.1101 16.1831 1.48285 15.7949 1.09491C15.407 0.70697 14.7798 0.70697 14.3918 1.09491L8.42769 7.05903L2.46375 1.09491C2.07563 0.70697 1.44856 0.70697 1.06062 1.09491C0.6725 1.48285 0.6725 2.1101 1.06062 2.49804L7.02456 8.46216L1.06062 14.4263C0.6725 14.8142 0.6725 15.4415 1.06062 15.8294C1.25396 16.0229 1.50816 16.1201 1.76219 16.1201C2.01621 16.1201 2.27024 16.0229 2.46375 15.8294L8.42769 9.86529L14.3918 15.8294C14.5853 16.0229 14.8394 16.1201 15.0934 16.1201C15.3474 16.1201 15.6014 16.0229 15.7949 15.8294C16.1831 15.4415 16.1831 14.8142 15.7949 14.4263L9.83101 8.46216Z"
        fill={color}
      />
    </svg>
  );
};

export const FailedIcon = ({ size }: { size?: number }) => {
  return (
    <svg
      width={`${size ?? "100"}`}
      height={`${size ?? "100"}`}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="failed-icon"
    >
      <path
        d="M100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100C77.6142 100 100 77.6142 100 50Z"
        fill="#D90000"
      />
      <path
        d="M71.2444 57.2233L55.9303 30.698C53.4289 26.3162 47.1035 26.3162 44.6112 30.698L29.2881 57.2233C26.7867 61.6052 29.8999 67.0488 34.9476 67.0488H65.5309C70.5786 67.0488 73.7458 61.5512 71.2444 57.2233ZM50.2617 61.1643C48.9301 61.1643 47.8234 60.0576 47.8234 58.7259C47.8234 57.3942 48.9301 56.2875 50.2617 56.2875C51.5934 56.2875 52.7001 57.3942 52.6461 58.7889C52.7091 60.0576 51.5394 61.1643 50.2617 61.1643ZM52.4842 45.4003C52.3762 47.2898 52.2592 49.1703 52.1513 51.0598C52.0973 51.6717 52.0973 52.2296 52.0973 52.8324C52.0433 53.8311 51.2605 54.6049 50.2617 54.6049C49.263 54.6049 48.4892 53.8851 48.4262 52.8864C48.2642 49.9441 48.0933 47.0559 47.9313 44.1136C47.8773 43.3398 47.8234 42.557 47.7604 41.7832C47.7604 40.5055 48.4802 39.4528 49.6499 39.1199C50.8196 38.841 51.9803 39.3988 52.4842 40.5055C52.6551 40.8924 52.7091 41.2793 52.7091 41.7292C52.6551 42.9619 52.5382 44.1856 52.4842 45.4003Z"
        fill="white"
      />
    </svg>
  );
};

export const PaymentWarningIcon = ({
  size = 56,
  className,
}: {
  size?: number;
  className?: string;
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      data-testid="payment-warning-icon"
    >
      <circle cx="28" cy="28" r="26" stroke="#efa73f" strokeWidth="2.5" />
      <text
        x="28"
        y="36"
        textAnchor="middle"
        fill="#efa73f"
        fontSize="28"
        fontWeight="bold"
        fontFamily="Inter, sans-serif"
      >
        !
      </text>
    </svg>
  );
};

export const SuccessIcon = ({ size }: { size?: number }) => {
  return (
    <svg
      width={size ? size : "122"}
      height={size ? size : "94"}
      viewBox="0 0 122 94"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="success-icon"
    >
      <path
        d="M99.2175 47.1436C99.2175 26.8153 82.6007 10.336 62.1029 10.336C41.6051 10.336 24.9883 26.8153 24.9883 47.1436C24.9883 67.4718 41.6051 83.9512 62.1029 83.9512C82.6007 83.9512 99.2175 67.4718 99.2175 47.1436Z"
        fill="#212121"
      />
      <path
        d="M94.8074 47.1437C94.8074 29.2307 80.1649 14.7093 62.1024 14.7093C44.04 14.7093 29.3975 29.2307 29.3975 47.1437C29.3975 65.0567 44.04 79.5781 62.1024 79.5781C80.1649 79.5781 94.8074 65.0567 94.8074 47.1437Z"
        fill="#248B3B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M78.5626 35.6872C78.8542 36.6511 78.3026 37.667 77.3307 37.9561C77.3331 37.9554 77.3328 37.9555 77.3296 37.9568C77.3141 37.9631 77.23 37.9968 77.063 38.0933C76.8756 38.2016 76.6364 38.3581 76.3439 38.5692C75.7585 38.9919 75.0326 39.5806 74.1898 40.3132C72.5075 41.7756 70.4499 43.732 68.2716 45.8908C63.9197 50.2037 59.1636 55.2468 56.114 58.5736C55.776 58.9423 55.3005 59.1577 54.7982 59.1695C54.2958 59.1814 53.8105 58.9887 53.4552 58.6363L45.7383 50.9833C45.0208 50.2717 45.0208 49.1179 45.7383 48.4063C46.4559 47.6947 47.6192 47.6947 48.3368 48.4063L54.6949 54.7119C57.7271 51.4398 61.8484 47.1044 65.6741 43.313C67.8749 41.1319 69.9973 39.1115 71.7677 37.5726C72.6512 36.8046 73.4698 36.1366 74.1811 35.623C74.8355 35.1506 75.5802 34.6721 76.2748 34.4655C77.2467 34.1763 78.271 34.7233 78.5626 35.6872Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M101.503 0.00383726C102.109 0.053981 102.56 0.582425 102.51 1.18415C102.318 3.46837 101.728 5.43443 100.336 6.75698C98.9173 8.10572 96.8946 8.57331 94.3445 8.37877C93.6132 8.32298 93.1006 8.48672 92.7201 8.73715C92.325 8.99721 91.9968 9.40166 91.7375 9.9332C91.2064 11.022 91.065 12.4408 91.1201 13.4234C91.1539 14.0263 90.6884 14.5422 90.0805 14.5756C89.4726 14.6091 88.9524 14.1476 88.9187 13.5447C88.8512 12.3407 89.0039 10.516 89.7528 8.98093C90.1335 8.20051 90.6918 7.44789 91.5009 6.91531C92.3246 6.37311 93.3341 6.10864 94.5136 6.19862C96.7406 6.36852 98.0252 5.92503 98.8109 5.17828C99.6241 4.40535 100.137 3.09152 100.312 1.00256C100.363 0.400838 100.896 -0.0463064 101.503 0.00383726Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.0984 24.8233C12.1943 25.1646 11.5163 25.811 11.1931 26.2689C10.844 26.7636 10.1566 26.8839 9.65782 26.5376C9.15903 26.1913 9.03773 25.5096 9.38688 25.015C9.92111 24.2581 10.9335 23.301 12.3139 22.7798C13.7415 22.2408 15.5182 22.189 17.4324 23.2244C19.24 24.2022 20.2586 25.1412 20.9985 25.8232C21.1428 25.9563 21.2766 26.0795 21.4035 26.1914C21.7829 26.5259 22.0663 26.7294 22.3944 26.8656C22.7192 27.0004 23.1636 27.0997 23.8864 27.0997C24.4953 27.0997 24.9889 27.5891 24.9889 28.1929C24.9889 28.7968 24.4953 29.2862 23.8864 29.2862C22.9557 29.2862 22.2058 29.1577 21.543 28.8826C20.8835 28.6088 20.386 28.22 19.9387 27.8257C19.784 27.6893 19.6315 27.5492 19.4749 27.4053C18.745 26.7346 17.9262 25.9822 16.3766 25.144C15.057 24.4302 13.9552 24.4998 13.0984 24.8233Z"
        fill="white"
      />
      <path
        opacity="0.3"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M116.503 47.0062C115.13 46.9673 113.83 47.4451 113.135 47.997C112.155 48.774 110.769 49.1079 109.601 49.2571C108.393 49.4114 107.209 49.3924 106.467 49.3254C105.86 49.2707 105.413 48.7389 105.468 48.1376C105.524 47.5363 106.06 47.0931 106.666 47.1478C107.271 47.2023 108.292 47.2197 109.319 47.0885C110.386 46.9522 111.267 46.6787 111.757 46.2896C112.899 45.3837 114.722 44.7682 116.565 44.8205C118.453 44.8739 120.475 45.6364 121.815 47.6301C122.153 48.1325 122.016 48.8113 121.509 49.1462C121.003 49.4812 120.318 49.3454 119.98 48.843C119.116 47.5569 117.831 47.0438 116.503 47.0062Z"
        fill="white"
      />
      <path
        d="M45.4645 4.20256C45.4645 5.81272 44.1483 7.11802 42.5247 7.11802C40.9011 7.11802 39.585 5.81272 39.585 4.20256C39.585 2.5924 40.9011 1.28711 42.5247 1.28711C44.1483 1.28711 45.4645 2.5924 45.4645 4.20256Z"
        fill="#DA0C2C"
      />
      <path
        d="M31.8366 80.7875C31.8366 82.3977 30.5204 83.703 28.8968 83.703C27.2732 83.703 25.957 82.3977 25.957 80.7875C25.957 79.1774 27.2732 77.8721 28.8968 77.8721C30.5204 77.8721 31.8366 79.1774 31.8366 80.7875Z"
        fill="#DA0C2C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M96.6914 71.328C96.6914 70.3217 97.514 69.5059 98.5288 69.5059C99.7575 69.5059 101.64 69.735 103.46 70.429C105.266 71.1174 107.271 72.3687 108.286 74.5828C108.706 75.4989 108.297 76.5792 107.373 76.9956C106.45 77.412 105.36 77.0069 104.94 76.0908C104.485 75.0978 103.49 74.3447 102.141 73.8306C100.807 73.3219 99.3823 73.1502 98.5288 73.1502C97.514 73.1502 96.6914 72.3344 96.6914 71.328Z"
        fill="white"
      />
      <path
        d="M106.207 21.8813L102.532 25.8901L106.207 29.17L109.882 25.5257L106.207 21.8813Z"
        fill="#E2D91E"
      />
      <path
        d="M50.3128 88.1689L47.373 91.3759L50.3128 93.9999L53.2526 91.0844L50.3128 88.1689Z"
        fill="#E2D91E"
      />
      <path
        d="M21.3128 54.0671C21.3128 54.8722 20.6547 55.5248 19.8429 55.5248C19.0311 55.5248 18.373 54.8722 18.373 54.0671C18.373 53.262 19.0311 52.6094 19.8429 52.6094C20.6547 52.6094 21.3128 53.262 21.3128 54.0671Z"
        fill="#C4C4C4"
      />
      <path
        opacity="0.3"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.1476 41.5775C13.8122 42.338 13.7293 43.4888 12.9624 44.1479C10.3697 46.3764 7.71633 46.9495 5.40615 46.5838C3.18854 46.2327 1.45381 45.0453 0.48727 44.0069C-0.201011 43.2674 -0.154514 42.1146 0.591123 41.432C1.33676 40.7494 2.49918 40.7955 3.18746 41.535C3.69081 42.0758 4.71211 42.7834 5.98548 42.985C7.16628 43.172 8.73887 42.9555 10.5558 41.3939C11.3226 40.7348 12.483 40.817 13.1476 41.5775Z"
        fill="white"
      />
    </svg>
  );
};

export const PhoneLogo = ({ color = "#248B3B" }: { color?: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.0001 16.9201V19.9201C22.0012 20.1986 21.9441 20.4743 21.8326 20.7294C21.721 20.9846 21.5574 21.2137 21.3521 21.402C21.1469 21.5902 20.9046 21.7336 20.6408 21.8228C20.377 21.912 20.0974 21.9452 19.8201 21.9201C16.7429 21.5857 13.7871 20.5342 11.1901 18.8501C8.77388 17.3148 6.72539 15.2663 5.19006 12.8501C3.50003 10.2413 2.4483 7.27109 2.12006 4.1801C2.09507 3.90356 2.12793 3.62486 2.21656 3.36172C2.30518 3.09859 2.44763 2.85679 2.63482 2.65172C2.82202 2.44665 3.04986 2.28281 3.30385 2.17062C3.55783 2.05843 3.8324 2.00036 4.11006 2.0001H7.11006C7.59536 1.99532 8.06585 2.16718 8.43382 2.48363C8.80179 2.80008 9.04213 3.23954 9.11005 3.7201C9.23668 4.68016 9.47151 5.62282 9.81006 6.5301C9.9446 6.88802 9.97372 7.27701 9.89396 7.65098C9.81421 8.02494 9.62892 8.36821 9.36005 8.6401L8.09006 9.9101C9.51361 12.4136 11.5865 14.4865 14.0901 15.9101L15.3601 14.6401C15.6319 14.3712 15.9752 14.1859 16.3492 14.1062C16.7231 14.0264 17.1121 14.0556 17.4701 14.1901C18.3773 14.5286 19.32 14.7635 20.2801 14.8901C20.7658 14.9586 21.2095 15.2033 21.5266 15.5776C21.8437 15.9519 22.0122 16.4297 22.0001 16.9201Z"
        fill={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export function RightArrow({
  rotate = 0,
  width = 8,
  height = 24,
  stroke = "white",
  strokeWidth = 2,
}: {
  rotate?: number;
  width?: number;
  height?: number;
  stroke?: "white" | "grey" | "grey5" | "black";
  strokeWidth?: 2 | 4;
}) {
  let strokeColor = "#fff";
  if (stroke === "white") {
    strokeColor = "white";
  } else if (stroke === "grey") {
    strokeColor = "#E1E1E180";
  } else if (stroke === "grey5") {
    strokeColor = "#CACACA";
  } else if (stroke === "black") {
    strokeColor = "#000";
  }

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 8 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="overflow-visible"
      style={{ transform: `rotate(${rotate}deg)` }}
    >
      <path
        d="M1 13L7 7L1 1"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function MailIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_2637_4953"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_2637_4953)">
        <path
          d="M4 20C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H20C20.55 4 21.0208 4.19583 21.4125 4.5875C21.8042 4.97917 22 5.45 22 6V18C22 18.55 21.8042 19.0208 21.4125 19.4125C21.0208 19.8042 20.55 20 20 20H4ZM12 13L4 8V18H20V8L12 13ZM12 11L20 6H4L12 11ZM4 8V6V18V8Z"
          fill="#D90000"
        />
      </g>
    </svg>
  );
}

export function PhoneRedIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.0001 16.9201V19.9201C22.0012 20.1986 21.9441 20.4743 21.8326 20.7294C21.721 20.9846 21.5574 21.2137 21.3521 21.402C21.1469 21.5902 20.9046 21.7336 20.6408 21.8228C20.377 21.912 20.0974 21.9452 19.8201 21.9201C16.7429 21.5857 13.7871 20.5342 11.1901 18.8501C8.77388 17.3148 6.72539 15.2663 5.19006 12.8501C3.50003 10.2413 2.4483 7.27109 2.12006 4.1801C2.09507 3.90356 2.12793 3.62486 2.21656 3.36172C2.30518 3.09859 2.44763 2.85679 2.63482 2.65172C2.82202 2.44665 3.04986 2.28281 3.30385 2.17062C3.55783 2.05843 3.8324 2.00036 4.11006 2.0001H7.11006C7.59536 1.99532 8.06585 2.16718 8.43382 2.48363C8.80179 2.80008 9.04213 3.23954 9.11005 3.7201C9.23668 4.68016 9.47151 5.62282 9.81006 6.5301C9.9446 6.88802 9.97372 7.27701 9.89396 7.65098C9.81421 8.02494 9.62892 8.36821 9.36005 8.6401L8.09006 9.9101C9.51361 12.4136 11.5865 14.4865 14.0901 15.9101L15.3601 14.6401C15.6319 14.3712 15.9752 14.1859 16.3492 14.1062C16.7231 14.0264 17.1121 14.0556 17.4701 14.1901C18.3773 14.5286 19.32 14.7635 20.2801 14.8901C20.7658 14.9586 21.2095 15.2033 21.5266 15.5776C21.8437 15.9519 22.0122 16.4297 22.0001 16.9201Z"
        stroke="#D90000"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function UserIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_2637_4965"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_2637_4965)">
        <path
          d="M12 12C10.9 12 9.95833 11.6083 9.175 10.825C8.39167 10.0417 8 9.1 8 8C8 6.9 8.39167 5.95833 9.175 5.175C9.95833 4.39167 10.9 4 12 4C13.1 4 14.0417 4.39167 14.825 5.175C15.6083 5.95833 16 6.9 16 8C16 9.1 15.6083 10.0417 14.825 10.825C14.0417 11.6083 13.1 12 12 12ZM4 20V17.2C4 16.6333 4.14583 16.1125 4.4375 15.6375C4.72917 15.1625 5.11667 14.8 5.6 14.55C6.63333 14.0333 7.68333 13.6458 8.75 13.3875C9.81667 13.1292 10.9 13 12 13C13.1 13 14.1833 13.1292 15.25 13.3875C16.3167 13.6458 17.3667 14.0333 18.4 14.55C18.8833 14.8 19.2708 15.1625 19.5625 15.6375C19.8542 16.1125 20 16.6333 20 17.2V20H4ZM6 18H18V17.2C18 17.0167 17.9542 16.85 17.8625 16.7C17.7708 16.55 17.65 16.4333 17.5 16.35C16.6 15.9 15.6917 15.5625 14.775 15.3375C13.8583 15.1125 12.9333 15 12 15C11.0667 15 10.1417 15.1125 9.225 15.3375C8.30833 15.5625 7.4 15.9 6.5 16.35C6.35 16.4333 6.22917 16.55 6.1375 16.7C6.04583 16.85 6 17.0167 6 17.2V18ZM12 10C12.55 10 13.0208 9.80417 13.4125 9.4125C13.8042 9.02083 14 8.55 14 8C14 7.45 13.8042 6.97917 13.4125 6.5875C13.0208 6.19583 12.55 6 12 6C11.45 6 10.9792 6.19583 10.5875 6.5875C10.1958 6.97917 10 7.45 10 8C10 8.55 10.1958 9.02083 10.5875 9.4125C10.9792 9.80417 11.45 10 12 10Z"
          fill="#D90000"
        />
      </g>
    </svg>
  );
}

export function SettingsIcon({
  color = "white",
  width = 24,
  height = 24,
}: {
  color?: string;
  width?: number;
  height?: number;
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3749_8766)">
        <path
          d="M19.4 15C19.2669 15.3016 19.2272 15.6362 19.286 15.9606C19.3448 16.285 19.4995 16.5843 19.73 16.82L19.79 16.88C19.976 17.0657 20.1235 17.2863 20.2241 17.5291C20.3248 17.7719 20.3766 18.0322 20.3766 18.295C20.3766 18.5578 20.3248 18.8181 20.2241 19.0609C20.1235 19.3037 19.976 19.5243 19.79 19.71C19.6043 19.896 19.3837 20.0435 19.1409 20.1441C18.8981 20.2448 18.6378 20.2966 18.375 20.2966C18.1122 20.2966 17.8519 20.2448 17.6091 20.1441C17.3663 20.0435 17.1457 19.896 16.96 19.71L16.9 19.65C16.6643 19.4195 16.365 19.2648 16.0406 19.206C15.7162 19.1472 15.3816 19.1869 15.08 19.32C14.7842 19.4468 14.532 19.6572 14.3543 19.9255C14.1766 20.1938 14.0813 20.5082 14.08 20.83V21C14.08 21.5304 13.8693 22.0391 13.4942 22.4142C13.1191 22.7893 12.6104 23 12.08 23C11.5496 23 11.0409 22.7893 10.6658 22.4142C10.2907 22.0391 10.08 21.5304 10.08 21V20.91C10.0723 20.579 9.96512 20.258 9.77251 19.9887C9.5799 19.7194 9.31074 19.5143 9 19.4C8.69838 19.2669 8.36381 19.2272 8.03941 19.286C7.71502 19.3448 7.41568 19.4995 7.18 19.73L7.12 19.79C6.93425 19.976 6.71368 20.1235 6.47088 20.2241C6.22808 20.3248 5.96783 20.3766 5.705 20.3766C5.44217 20.3766 5.18192 20.3248 4.93912 20.2241C4.69632 20.1235 4.47575 19.976 4.29 19.79C4.10405 19.6043 3.95653 19.3837 3.85588 19.1409C3.75523 18.8981 3.70343 18.6378 3.70343 18.375C3.70343 18.1122 3.75523 17.8519 3.85588 17.6091C3.95653 17.3663 4.10405 17.1457 4.29 16.96L4.35 16.9C4.58054 16.6643 4.73519 16.365 4.794 16.0406C4.85282 15.7162 4.81312 15.3816 4.68 15.08C4.55324 14.7842 4.34276 14.532 4.07447 14.3543C3.80618 14.1766 3.49179 14.0813 3.17 14.08H3C2.46957 14.08 1.96086 13.8693 1.58579 13.4942C1.21071 13.1191 1 12.6104 1 12.08C1 11.5496 1.21071 11.0409 1.58579 10.6658C1.96086 10.2907 2.46957 10.08 3 10.08H3.09C3.42099 10.0723 3.742 9.96512 4.0113 9.77251C4.28059 9.5799 4.48572 9.31074 4.6 9C4.73312 8.69838 4.77282 8.36381 4.714 8.03941C4.65519 7.71502 4.50054 7.41568 4.27 7.18L4.21 7.12C4.02405 6.93425 3.87653 6.71368 3.77588 6.47088C3.67523 6.22808 3.62343 5.96783 3.62343 5.705C3.62343 5.44217 3.67523 5.18192 3.77588 4.93912C3.87653 4.69632 4.02405 4.47575 4.21 4.29C4.39575 4.10405 4.61632 3.95653 4.85912 3.85588C5.10192 3.75523 5.36217 3.70343 5.625 3.70343C5.88783 3.70343 6.14808 3.75523 6.39088 3.85588C6.63368 3.95653 6.85425 4.10405 7.04 4.29L7.1 4.35C7.33568 4.58054 7.63502 4.73519 7.95941 4.794C8.28381 4.85282 8.61838 4.81312 8.92 4.68H9C9.29577 4.55324 9.54802 4.34276 9.72569 4.07447C9.90337 3.80618 9.99872 3.49179 10 3.17V3C10 2.46957 10.2107 1.96086 10.5858 1.58579C10.9609 1.21071 11.4696 1 12 1C12.5304 1 13.0391 1.21071 13.4142 1.58579C13.7893 1.96086 14 2.46957 14 3V3.09C14.0013 3.41179 14.0966 3.72618 14.2743 3.99447C14.452 4.26276 14.7042 4.47324 15 4.6C15.3016 4.73312 15.6362 4.77282 15.9606 4.714C16.285 4.65519 16.5843 4.50054 16.82 4.27L16.88 4.21C17.0657 4.02405 17.2863 3.87653 17.5291 3.77588C17.7719 3.67523 18.0322 3.62343 18.295 3.62343C18.5578 3.62343 18.8181 3.67523 19.0609 3.77588C19.3037 3.87653 19.5243 4.02405 19.71 4.21C19.896 4.39575 20.0435 4.61632 20.1441 4.85912C20.2448 5.10192 20.2966 5.36217 20.2966 5.625C20.2966 5.88783 20.2448 6.14808 20.1441 6.39088C20.0435 6.63368 19.896 6.85425 19.71 7.04L19.65 7.1C19.4195 7.33568 19.2648 7.63502 19.206 7.95941C19.1472 8.28381 19.1869 8.61838 19.32 8.92V9C19.4468 9.29577 19.6572 9.54802 19.9255 9.72569C20.1938 9.90337 20.5082 9.99872 20.83 10H21C21.5304 10 22.0391 10.2107 22.4142 10.5858C22.7893 10.9609 23 11.4696 23 12C23 12.5304 22.7893 13.0391 22.4142 13.4142C22.0391 13.7893 21.5304 14 21 14H20.91C20.5882 14.0013 20.2738 14.0966 20.0055 14.2743C19.7372 14.452 19.5268 14.7042 19.4 15Z"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3749_8766">
          <path
            d="M0 5C0 2.23858 2.23858 0 5 0H19C21.7614 0 24 2.23858 24 5V24H0V5Z"
            fill={color}
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export const ArrowDownIcon = ({
  color = "white",
  rotate = 0,
  width = 14,
  height = 14,
}: {
  color?: string;
  rotate?: number;
  width?: number;
  height?: number;
}) => {
  const style = { transform: `rotate(${rotate}deg)` };
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M3.5 5.25L7 8.75L10.5 5.25"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const RetryIcon = ({
  color = "#fff",
  width,
  height,
}: {
  width?: number;
  height?: number;
  color?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 256 256"
      width={width}
      height={height}
      style={{ mixBlendMode: "normal" }}
    >
      <g
        fill={color}
        fillRule="nonzero"
        stroke="none"
        strokeWidth="1"
        strokeLinecap="butt"
        strokeLinejoin="miter"
        strokeMiterlimit="10"
        strokeDasharray=""
        strokeDashoffset="0"
        fontFamily="none"
        fontWeight="none"
        fontSize="none"
      >
        <g transform="scale(5.12,5.12)">
          <path d="M25,2c-0.36064,-0.0051 -0.69608,0.18438 -0.87789,0.49587c-0.18181,0.3115 -0.18181,0.69676 0,1.00825c0.18181,0.3115 0.51725,0.50097 0.87789,0.49587c11.60953,0 21,9.39047 21,21c0,11.60953 -9.39047,21 -21,21c-11.60953,0 -21,-9.39047 -21,-21c0,-6.69269 3.13071,-12.63519 8,-16.48047v6.48047c-0.0051,0.36064 0.18438,0.69608 0.49587,0.87789c0.3115,0.18181 0.69676,0.18181 1.00825,0c0.3115,-0.18181 0.50097,-0.51725 0.49587,-0.87789v-8.44922v-1.55078h-10c-0.36064,-0.0051 -0.69608,0.18438 -0.87789,0.49587c-0.18181,0.3115 -0.18181,0.69676 0,1.00825c0.18181,0.3115 0.51725,0.50097 0.87789,0.49587h6.69922c-5.29713,4.21481 -8.69922,10.7122 -8.69922,18c0,12.69047 10.30953,23 23,23c12.69047,0 23,-10.30953 23,-23c0,-12.69047 -10.30953,-23 -23,-23z"></path>
        </g>
      </g>
    </svg>
  );
};

export const ActionClapperIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.88458 12.7303L22.7055 7.0347L21.6801 4.3667L5.53613 10.5707L6.30858 12.5805M24.6664 16.6209V24.4311C24.6664 24.7848 24.5259 25.1239 24.2758 25.374C24.0258 25.624 23.6866 25.7645 23.333 25.7645H8.70547C8.35184 25.7645 8.01271 25.624 7.76266 25.374C7.51261 25.1239 7.37213 24.7848 7.37213 24.4311V16.6209H24.6664ZM24.6664 16.6209L24.6668 13.7627H8.39835M7.37213 16.4667V15.0925"
        stroke="#B2B2B2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.75488 16.6209H10.8362L13.3824 13.7627H11.3011L8.75488 16.6209ZM14.0882 16.6209H16.1695L18.7158 13.7627H16.6344L14.0882 16.6209ZM19.4215 16.6209H21.5029L24.0491 13.7627H21.9678L19.4215 16.6209Z"
        stroke="#B2B2B2"
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.02127 14.8787C7.63762 14.8787 8.13727 14.3791 8.13727 13.7627C8.13727 13.1464 7.63762 12.6467 7.02127 12.6467C6.40492 12.6467 5.90527 13.1464 5.90527 13.7627C5.90527 14.3791 6.40492 14.8787 7.02127 14.8787Z"
        stroke="#B2B2B2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.2796 7.59293L17.8774 5.83871L19.8201 5.09204L22.4876 6.46715M18.1205 8.80493L16.1774 9.55071L12.7761 7.79382L14.7196 7.04849L18.1205 8.80493ZM13.2045 10.6992L11.2561 11.4307L7.86719 9.65026L9.81563 8.91871L13.2045 10.6992Z"
        stroke="#B2B2B2"
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DownloadIcon = ({ color }: { color?: string }) => {
  return (
    <svg
      width="18"
      height="24"
      viewBox="0 0 18 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ color: color || "#B2B2B2" }}
    >
      <path
        d="M1 22.6667H17M9 1.33337V17.3334M9 17.3334L13.6667 12.6667M9 17.3334L4.33333 12.6667"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const TvIcon = ({ color }: { color?: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ color: color || "#B2B2B2" }}
    >
      <path
        d="M6 20.25H18M10.5 17.25V20.25M13.5 17.25V20.25M3.375 17.25H20.625C21.246 17.25 21.75 16.746 21.75 16.125V4.875C21.75 4.254 21.246 3.75 20.625 3.75H3.375C2.754 3.75 2.25 4.254 2.25 4.875V16.125C2.25 16.746 2.754 17.25 3.375 17.25Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const RightArrowLoginButton = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M7.5 15L12.5 10L7.5 5"
        stroke="#F0F0F0"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CouponIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="coupon-icon"
    >
      <path
        d="M14.8 8L16 9.2L9.2 16L8 14.8L14.8 8ZM4 4H20C21.11 4 22 4.89 22 6V10C21.4696 10 20.9609 10.2107 20.5858 10.5858C20.2107 10.9609 20 11.4696 20 12C20 12.5304 20.2107 13.0391 20.5858 13.4142C20.9609 13.7893 21.4696 14 22 14V18C22 19.11 21.11 20 20 20H4C3.46957 20 2.96086 19.7893 2.58579 19.4142C2.21071 19.0391 2 18.5304 2 18V14C3.11 14 4 13.11 4 12C4 11.4696 3.78929 10.9609 3.41421 10.5858C3.03914 10.2107 2.53043 10 2 10V6C2 5.46957 2.21071 4.96086 2.58579 4.58579C2.96086 4.21071 3.46957 4 4 4ZM4 6V8.54C4.60768 8.8904 5.11236 9.39466 5.46325 10.0021C5.81415 10.6094 5.9989 11.2985 5.9989 12C5.9989 12.7015 5.81415 13.3906 5.46325 13.9979C5.11236 14.6053 4.60768 15.1096 4 15.46V18H20V15.46C19.3923 15.1096 18.8876 14.6053 18.5367 13.9979C18.1858 13.3906 18.0011 12.7015 18.0011 12C18.0011 11.2985 18.1858 10.6094 18.5367 10.0021C18.8876 9.39466 19.3923 8.8904 20 8.54V6H4ZM9.5 8C10.33 8 11 8.67 11 9.5C11 10.33 10.33 11 9.5 11C8.67 11 8 10.33 8 9.5C8 8.67 8.67 8 9.5 8ZM14.5 13C15.33 13 16 13.67 16 14.5C16 15.33 15.33 16 14.5 16C13.67 16 13 15.33 13 14.5C13 13.67 13.67 13 14.5 13Z"
        fill="#B2B2B2"
      />
    </svg>
  );
};

export const MoviesIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.91366 9.54806L17.0293 5.27639L16.2603 3.27539L4.15233 7.92839L4.73166 9.43572M18.5 12.4661V18.3237C18.5 18.5889 18.3946 18.8433 18.2071 19.0308C18.0196 19.2184 17.7652 19.3237 17.5 19.3237H6.52933C6.26411 19.3237 6.00976 19.2184 5.82222 19.0308C5.63469 18.8433 5.52933 18.5889 5.52933 18.3237V12.4661H18.5ZM18.5 12.4661L18.5003 10.3224H6.299M5.52933 12.3504V11.3197"
        stroke="#F1F1F1"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.56667 12.4659H8.12767L10.0373 10.3223H8.47633L6.56667 12.4659ZM10.5667 12.4659H12.1277L14.0373 10.3223H12.4763L10.5667 12.4659ZM14.5667 12.4659H16.1277L18.0373 10.3223H16.4763L14.5667 12.4659Z"
        stroke="#F1F1F1"
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.26632 11.1594C5.72858 11.1594 6.10332 10.7846 6.10332 10.3224C6.10332 9.86009 5.72858 9.48535 5.26632 9.48535C4.80406 9.48535 4.42932 9.86009 4.42932 10.3224C4.42932 10.7846 4.80406 11.1594 5.26632 11.1594Z"
        stroke="#F1F1F1"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.9597 5.695L13.408 4.37934L14.865 3.81934L16.8657 4.85067M13.5903 6.604L12.133 7.16334L9.582 5.84567L11.0397 5.28667L13.5903 6.604ZM9.90333 8.02467L8.442 8.57334L5.90033 7.238L7.36166 6.68934L9.90333 8.02467Z"
        stroke="#F1F1F1"
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const TickIcon = ({
  color = "white",
  width = 12,
  height = 12,
}: {
  color?: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.2 6.52 4.4 9.6 10.8 3"
        stroke="#000"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CheckIcon = ({
  type = "light",
  className,
}: {
  type?: "light" | "dark";
  className?: string;
}) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M20 6L9 17L4 12"
      stroke={type === "light" ? "white" : "black"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const InstagramIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M10.3496 0.89502C13.9447 0.89502 15.7424 0.894824 17.0371 1.75146C17.6153 2.13402 18.1106 2.62936 18.4932 3.20752C19.3498 4.50225 19.3496 6.29995 19.3496 9.89502C19.3496 13.4901 19.3498 15.2878 18.4932 16.5825C18.1106 17.1607 17.6153 17.656 17.0371 18.0386C15.7424 18.8952 13.9447 18.895 10.3496 18.895C6.75454 18.895 4.95684 18.8952 3.66211 18.0386C3.08395 17.656 2.58861 17.1607 2.20605 16.5825C1.34941 15.2878 1.34961 13.4901 1.34961 9.89502C1.34961 6.29995 1.34941 4.50225 2.20605 3.20752C2.58861 2.62936 3.08395 2.13402 3.66211 1.75146C4.95684 0.894824 6.75454 0.89502 10.3496 0.89502ZM10.3496 5.23584C7.77636 5.23584 5.69055 7.3218 5.69043 9.89502C5.69043 12.4683 7.77629 14.5542 10.3496 14.5542C12.9229 14.5541 15.0088 12.4683 15.0088 9.89502C15.0087 7.32186 12.9228 5.23593 10.3496 5.23584ZM10.3496 6.81201C12.0522 6.8121 13.4325 8.19248 13.4326 9.89502C13.4326 11.5977 12.0522 12.9779 10.3496 12.978C8.64691 12.978 7.2666 11.5977 7.2666 9.89502C7.26672 8.19243 8.64699 6.81201 10.3496 6.81201ZM15.1934 3.90674C14.5888 3.90674 14.0978 4.39694 14.0977 5.00146C14.0977 5.60612 14.5887 6.09619 15.1934 6.09619C15.7978 6.09593 16.2881 5.60596 16.2881 5.00146C16.2879 4.3971 15.7977 3.90699 15.1934 3.90674Z"
      fill="white"
    />
  </svg>
);

export const FacebookIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="20"
    viewBox="0 0 12 20"
    fill="none"
  >
    <path
      d="M7.81339 18.895V10.6844H10.7081L11.1415 7.48452H7.81331V5.44155C7.81331 4.51512 8.08348 3.88381 9.47893 3.88381L11.2586 3.88301V1.02109C10.9508 0.982165 9.89429 0.89502 8.66531 0.89502C6.09929 0.89502 4.34255 2.38619 4.34255 5.12474V7.48452H1.44043V10.6844H4.34255V18.8949H7.81339V18.895Z"
      fill="white"
    />
  </svg>
);

export const YoutubeIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="16"
    viewBox="0 0 22 16"
    fill="none"
  >
    <path
      d="M11.7882 14.8749L7.72605 14.799C6.4108 14.7726 5.09228 14.8254 3.80282 14.5513C1.84126 14.1418 1.70229 12.1339 1.55688 10.4496C1.35652 8.0818 1.43409 5.67098 1.81219 3.32291C2.02565 2.00539 2.86568 1.21922 4.16476 1.13367C8.55011 0.823192 12.9646 0.859987 17.3403 1.00483C17.8024 1.01811 18.2677 1.09069 18.7234 1.1733C20.9727 1.57622 21.0275 3.85161 21.1733 5.76707C21.3187 7.70229 21.2573 9.64745 20.9794 11.5695C20.7564 13.1609 20.3298 14.4954 18.5294 14.6243C16.2737 14.7927 14.0697 14.9284 11.8076 14.8852C11.8077 14.8749 11.7947 14.8749 11.7882 14.8749ZM9.40006 10.846C11.1 9.84856 12.7674 8.86777 14.4576 7.87704C12.7545 6.87963 11.0902 5.89884 9.40006 4.90812V10.846Z"
      fill="white"
    />
  </svg>
);

export const AppStoreIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="136"
    height="40"
    viewBox="0 0 136 40"
    fill="none"
  >
    <rect width="136" height="40" rx="8" fill="#1A1A1A" />
    <path
      d="M29.5959 19.0291C29.5666 15.8061 32.2544 14.2381 32.3773 14.1651C30.8551 11.9621 28.4958 11.6611 27.6667 11.6371C25.6851 11.4301 23.763 12.8141 22.7535 12.8141C21.724 12.8141 20.1695 11.6571 18.4942 11.6911C16.3384 11.7241 14.3215 12.9631 13.2154 14.8871C10.9326 18.8101 12.6351 24.5751 14.8222 27.7461C15.9163 29.2991 17.1947 31.0331 18.868 30.9721C20.505 30.9051 21.1165 29.9361 23.092 29.9361C25.0494 29.9361 25.6237 30.9721 27.3302 30.9331C29.0871 30.9051 30.1933 29.3731 31.249 27.8061C32.5133 26.0261 33.021 24.2731 33.0412 24.1831C32.9999 24.1691 29.6291 22.8921 29.5959 19.0291Z"
      fill="white"
    />
    <path
      d="M26.3722 9.55111C27.2526 8.45811 27.8551 6.97111 27.6878 5.46211C26.4135 5.51811 24.8197 6.33711 23.902 7.40611C23.09 8.34811 22.3647 9.89211 22.5521 11.3441C23.9836 11.4501 25.4534 10.6271 26.3722 9.55111Z"
      fill="white"
    />
    <path
      d="M48.658 9.25413C48.658 10.4311 48.3023 11.3171 47.5921 11.9121C46.9343 12.4611 45.9994 12.7361 44.7885 12.7361C44.1881 12.7361 43.6743 12.7101 43.2441 12.6581V6.22713C43.8053 6.13713 44.4097 6.09113 45.0625 6.09113C46.216 6.09113 47.0854 6.34013 47.6717 6.83813C48.3285 7.40113 48.658 8.20613 48.658 9.25413ZM47.5448 9.28313C47.5448 8.52013 47.3413 7.93513 46.9343 7.52713C46.5273 7.12012 45.9329 6.91613 45.1502 6.91613C44.8177 6.91613 44.5346 6.93813 44.2999 6.98413V11.8731C44.4299 11.8931 44.6676 11.9021 45.0132 11.9021C45.8211 11.9021 46.4447 11.6791 46.8839 11.2331C47.3231 10.7871 47.5448 10.1371 47.5448 9.28313Z"
      fill="white"
    />
    <path
      d="M54.5604 10.2821C54.5604 11.0071 54.3519 11.6011 53.9348 12.0671C53.4976 12.5461 52.9183 12.7851 52.195 12.7851C51.4979 12.7851 50.9428 12.5561 50.5287 12.0961C50.1157 11.6371 49.9092 11.0581 49.9092 10.3601C49.9092 9.63012 50.1217 9.03112 50.5489 8.56612C50.976 8.10112 51.5502 7.86812 52.2736 7.86812C52.9707 7.86812 53.5308 8.09712 53.9549 8.55612C54.3579 9.00212 54.5604 9.57812 54.5604 10.2821ZM53.4653 10.3161C53.4653 9.88112 53.3706 9.50812 53.1823 9.19712C52.9606 8.82112 52.6453 8.63312 52.2353 8.63312C51.8112 8.63312 51.4888 8.82112 51.2672 9.19712C51.0778 9.50812 50.9841 9.88712 50.9841 10.3351C50.9841 10.7701 51.0788 11.1431 51.2672 11.4541C51.4958 11.8301 51.8142 12.0181 52.2252 12.0181C52.6282 12.0181 52.9445 11.8271 53.1722 11.4441C53.3676 11.1271 53.4653 10.7511 53.4653 10.3161Z"
      fill="white"
    />
    <path
      d="M62.4746 7.96412L60.9887 12.6781H60.0215L59.406 10.6311C59.2499 10.1201 59.1229 9.61212 59.0242 9.10812H59.0051C58.9134 9.62612 58.7865 10.1331 58.6233 10.6311L57.9695 12.6781H56.9913L55.594 7.96412H56.679L57.2159 10.2051C57.3459 10.7351 57.4527 11.2401 57.5383 11.7181H57.5574C57.636 11.3241 57.766 10.8221 57.9493 10.2151L58.6233 7.96512H59.4836L60.1293 10.1671C60.2855 10.7041 60.4124 11.2211 60.5101 11.7191H60.5394C60.6109 11.2341 60.7187 10.7171 60.8617 10.1671L61.438 7.96512H62.4746V7.96412Z"
      fill="white"
    />
    <path
      d="M67.9477 12.6781H66.892V9.97813C66.892 9.14613 66.5736 8.73013 65.935 8.73013C65.6216 8.73013 65.3688 8.84413 65.1724 9.07313C64.9779 9.30213 64.8792 9.57213 64.8792 9.88113V12.6771H63.8234V9.31113C63.8234 8.89713 63.8103 8.44813 63.7852 7.96213H64.713L64.7623 8.69913H64.7916C64.9145 8.47013 65.0978 8.28113 65.3386 8.13013C65.6247 7.95413 65.945 7.86513 66.2956 7.86513C66.7389 7.86513 67.1076 8.00713 67.4007 8.29213C67.7654 8.64113 67.9477 9.16213 67.9477 9.85413V12.6781V12.6781Z"
      fill="white"
    />
    <path d="M70.8592 12.6781H69.8044V5.80112H70.8592V12.6781Z" fill="white" />
    <path
      d="M77.075 10.2821C77.075 11.0071 76.8665 11.6011 76.4494 12.0671C76.0122 12.5461 75.432 12.7851 74.7096 12.7851C74.0115 12.7851 73.4564 12.5561 73.0434 12.0961C72.6303 11.6371 72.4238 11.0581 72.4238 10.3601C72.4238 9.63012 72.6364 9.03112 73.0635 8.56612C73.4907 8.10112 74.0649 7.86812 74.7872 7.86812C75.4853 7.86812 76.0445 8.09712 76.4696 8.55612C76.8725 9.00212 77.075 9.57812 77.075 10.2821ZM75.979 10.3161C75.979 9.88112 75.8843 9.50812 75.6959 9.19712C75.4753 8.82112 75.1589 8.63312 74.7499 8.63312C74.3248 8.63312 74.0024 8.82112 73.7818 9.19712C73.5924 9.50812 73.4987 9.88712 73.4987 10.3351C73.4987 10.7701 73.5934 11.1431 73.7818 11.4541C74.0105 11.8301 74.3288 12.0181 74.7399 12.0181C75.1428 12.0181 75.4581 11.8271 75.6858 11.4441C75.8823 11.1271 75.979 10.7511 75.979 10.3161Z"
      fill="white"
    />
    <path
      d="M82.1845 12.6781H81.2366L81.158 12.1351H81.1288C80.8044 12.5681 80.342 12.7851 79.7416 12.7851C79.2933 12.7851 78.9306 12.6421 78.6576 12.3581C78.4098 12.1001 78.2859 11.7791 78.2859 11.3981C78.2859 10.8221 78.5277 10.3831 79.0142 10.0791C79.4998 9.77512 80.1828 9.62612 81.0623 9.63312V9.54512C81.0623 8.92412 80.7339 8.61412 80.076 8.61412C79.6076 8.61412 79.1946 8.73112 78.838 8.96312L78.6234 8.27512C79.0646 8.00412 79.6096 7.86812 80.2523 7.86812C81.4935 7.86812 82.116 8.51812 82.116 9.81812V11.5541C82.116 12.0251 82.1392 12.4001 82.1845 12.6781ZM81.0885 11.0581V10.3311C79.9239 10.3111 79.3417 10.6281 79.3417 11.2811C79.3417 11.5271 79.4081 11.7111 79.5441 11.8341C79.6801 11.9571 79.8534 12.0181 80.0599 12.0181C80.2916 12.0181 80.5082 11.9451 80.7057 11.8001C80.9041 11.6541 81.026 11.4691 81.0714 11.2421C81.0824 11.1911 81.0885 11.1291 81.0885 11.0581Z"
      fill="white"
    />
    <path
      d="M88.1835 12.6781H87.2466L87.1972 11.9211H87.168C86.8688 12.4971 86.3591 12.7851 85.6428 12.7851C85.0706 12.7851 84.5941 12.5621 84.2163 12.1161C83.8385 11.6701 83.6501 11.0911 83.6501 10.3801C83.6501 9.61712 83.8546 8.99912 84.2657 8.52712C84.6636 8.08712 85.1512 7.86712 85.7314 7.86712C86.3691 7.86712 86.8154 8.08012 87.0693 8.50712H87.0894V5.80112H88.1462V11.4081C88.1462 11.8671 88.1583 12.2901 88.1835 12.6781ZM87.0894 10.6901V9.90412C87.0894 9.76812 87.0793 9.65812 87.0602 9.57412C87.0008 9.32212 86.8728 9.11012 86.6784 8.93912C86.482 8.76812 86.2452 8.68212 85.9722 8.68212C85.5783 8.68212 85.2701 8.83712 85.0434 9.14812C84.8187 9.45912 84.7049 9.85612 84.7049 10.3411C84.7049 10.8071 84.8127 11.1851 85.0293 11.4761C85.258 11.7861 85.5662 11.9411 85.9521 11.9411C86.2986 11.9411 86.5757 11.8121 86.7862 11.5531C86.9897 11.3141 87.0894 11.0261 87.0894 10.6901Z"
      fill="white"
    />
    <path
      d="M97.213 10.2821C97.213 11.0071 97.0044 11.6011 96.5874 12.0671C96.1502 12.5461 95.5719 12.7851 94.8476 12.7851C94.1515 12.7851 93.5964 12.5561 93.1813 12.0961C92.7683 11.6371 92.5618 11.0581 92.5618 10.3601C92.5618 9.63012 92.7743 9.03112 93.2015 8.56612C93.6286 8.10112 94.2028 7.86812 94.9272 7.86812C95.6233 7.86812 96.1844 8.09712 96.6075 8.55612C97.0105 9.00212 97.213 9.57812 97.213 10.2821ZM96.1189 10.3161C96.1189 9.88112 96.0242 9.50812 95.8358 9.19712C95.6132 8.82112 95.2989 8.63312 94.8879 8.63312C94.4648 8.63312 94.1424 8.82112 93.9198 9.19712C93.7304 9.50812 93.6367 9.88712 93.6367 10.3351C93.6367 10.7701 93.7314 11.1431 93.9198 11.4541C94.1484 11.8301 94.4668 12.0181 94.8778 12.0181C95.2808 12.0181 95.5981 11.8271 95.8258 11.4441C96.0202 11.1271 96.1189 10.7511 96.1189 10.3161Z"
      fill="white"
    />
    <path
      d="M102.89 12.6781H101.835V9.97813C101.835 9.14613 101.517 8.73013 100.877 8.73013C100.564 8.73013 100.311 8.84413 100.115 9.07313C99.9198 9.30213 99.8221 9.57213 99.8221 9.88113V12.6771H98.7653V9.31113C98.7653 8.89713 98.7532 8.44813 98.728 7.96213H99.6548L99.7042 8.69913H99.7334C99.8573 8.47013 100.041 8.28113 100.28 8.13013C100.568 7.95413 100.887 7.86513 101.238 7.86513C101.681 7.86513 102.049 8.00713 102.343 8.29213C102.708 8.64113 102.89 9.16213 102.89 9.85413V12.6781V12.6781Z"
      fill="white"
    />
    <path
      d="M109.995 8.74912H108.832V11.0391C108.832 11.6211 109.039 11.9121 109.448 11.9121C109.637 11.9121 109.795 11.8961 109.918 11.8631L109.946 12.6581C109.737 12.7361 109.463 12.7751 109.126 12.7751C108.709 12.7751 108.384 12.6491 108.149 12.3971C107.914 12.1451 107.797 11.7211 107.797 11.1261V8.74912H107.103V7.96412H107.797V7.10012L108.831 6.79012V7.96312H109.994V8.74912H109.995Z"
      fill="white"
    />
    <path
      d="M115.584 12.6781H114.527V9.99812C114.527 9.15312 114.209 8.73012 113.571 8.73012C113.082 8.73012 112.747 8.97512 112.564 9.46512C112.533 9.56812 112.514 9.69412 112.514 9.84212V12.6771H111.46V5.80112H112.514V8.64212H112.535C112.867 8.12512 113.344 7.86712 113.961 7.86712C114.398 7.86712 114.76 8.00912 115.047 8.29412C115.405 8.64912 115.584 9.17712 115.584 9.87512V12.6781V12.6781Z"
      fill="white"
    />
    <path
      d="M121.349 10.0981C121.349 10.2861 121.335 10.4441 121.31 10.5731H118.144C118.158 11.0391 118.309 11.3941 118.602 11.6401C118.87 11.8601 119.216 11.9701 119.639 11.9701C120.107 11.9701 120.534 11.8961 120.919 11.7471L121.085 12.4751C120.634 12.6691 120.104 12.7661 119.491 12.7661C118.755 12.7661 118.176 12.5511 117.757 12.1211C117.336 11.6911 117.127 11.1141 117.127 10.3901C117.127 9.67912 117.322 9.08711 117.714 8.61512C118.123 8.11112 118.676 7.85912 119.374 7.85912C120.057 7.85912 120.576 8.11112 120.926 8.61512C121.209 9.01511 121.349 9.51011 121.349 10.0981ZM120.342 9.82711C120.35 9.51611 120.281 9.24812 120.138 9.02212C119.954 8.73112 119.675 8.58512 119.297 8.58512C118.953 8.58512 118.672 8.72712 118.457 9.01212C118.282 9.23912 118.178 9.51011 118.144 9.82711H120.342Z"
      fill="white"
    />
    <path
      d="M53.287 30.7491H50.9991L49.7459 26.8401H45.3899L44.1961 30.7491H41.9688L46.2845 17.4411H48.9501L53.287 30.7491ZM49.3682 25.2001L48.2348 21.7251C48.1149 21.3701 47.8903 20.5341 47.5589 19.2181H47.5186C47.3866 19.7841 47.174 20.6201 46.8819 21.7251L45.7687 25.2001H49.3682V25.2001Z"
      fill="white"
    />
    <path
      d="M64.3856 25.8331C64.3856 27.4651 63.9414 28.7551 63.0528 29.7021C62.257 30.5451 61.2687 30.9661 60.089 30.9661C58.8157 30.9661 57.9009 30.5121 57.3438 29.6041H57.3035V34.6591H55.1558V24.3121C55.1558 23.2861 55.1286 22.2331 55.0762 21.1531H56.9651L57.0849 22.6741H57.1252C57.8415 21.5281 58.9285 20.9561 60.3872 20.9561C61.5276 20.9561 62.4796 21.4031 63.2412 22.2981C64.0048 23.1941 64.3856 24.3721 64.3856 25.8331ZM62.1975 25.9111C62.1975 24.9771 61.986 24.2071 61.5609 23.6011C61.0964 22.9691 60.4729 22.6531 59.6911 22.6531C59.1612 22.6531 58.6797 22.8291 58.2495 23.1761C57.8183 23.5261 57.5363 23.9831 57.4043 24.5491C57.3378 24.8131 57.3046 25.0291 57.3046 25.1991V26.7991C57.3046 27.4971 57.5201 28.0861 57.9513 28.5671C58.3825 29.0481 58.9426 29.2881 59.6317 29.2881C60.4406 29.2881 61.0702 28.9781 61.5206 28.3601C61.9719 27.7411 62.1975 26.9251 62.1975 25.9111Z"
      fill="white"
    />
    <path
      d="M75.5042 25.8331C75.5042 27.4651 75.06 28.7551 74.1704 29.7021C73.3756 30.5451 72.3873 30.9661 71.2077 30.9661C69.9343 30.9661 69.0196 30.5121 68.4635 29.6041H68.4232V34.6591H66.2754V24.3121C66.2754 23.2861 66.2482 22.2331 66.1958 21.1531H68.0847L68.2046 22.6741H68.2449C68.9601 21.5281 70.0471 20.9561 71.5069 20.9561C72.6462 20.9561 73.5982 21.4031 74.3619 22.2981C75.1224 23.1941 75.5042 24.3721 75.5042 25.8331ZM73.3162 25.9111C73.3162 24.9771 73.1036 24.2071 72.6785 23.6011C72.2141 22.9691 71.5925 22.6531 70.8097 22.6531C70.2788 22.6531 69.7983 22.8291 69.3671 23.1761C68.936 23.5261 68.6549 23.9831 68.5229 24.5491C68.4574 24.8131 68.4232 25.0291 68.4232 25.1991V26.7991C68.4232 27.4971 68.6388 28.0861 69.0679 28.5671C69.4991 29.0471 70.0592 29.2881 70.7503 29.2881C71.5592 29.2881 72.1889 28.9781 72.6392 28.3601C73.0905 27.7411 73.3162 26.9251 73.3162 25.9111Z"
      fill="white"
    />
    <path
      d="M87.9358 27.0171C87.9358 28.1491 87.5399 29.0701 86.7451 29.7811C85.8716 30.5581 84.6557 30.9461 83.0932 30.9461C81.6506 30.9461 80.4941 30.6701 79.6187 30.1171L80.1163 28.3401C81.0592 28.9061 82.0939 29.1901 83.2211 29.1901C84.0301 29.1901 84.6597 29.0081 85.112 28.6461C85.5624 28.2841 85.787 27.7981 85.787 27.1921C85.787 26.6521 85.6016 26.1971 85.2299 25.8281C84.8602 25.4591 84.2427 25.1161 83.3803 24.7991C81.0331 23.9301 79.8604 22.6571 79.8604 20.9831C79.8604 19.8891 80.2715 18.9921 81.0945 18.2941C81.9145 17.5951 83.0086 17.2461 84.3766 17.2461C85.5966 17.2461 86.6101 17.4571 87.419 17.8781L86.8821 19.6161C86.1265 19.2081 85.2722 19.0041 84.3162 19.0041C83.5606 19.0041 82.9703 19.1891 82.5472 19.5571C82.1896 19.8861 82.0102 20.2871 82.0102 20.7621C82.0102 21.2881 82.2147 21.7231 82.6258 22.0651C82.9834 22.3811 83.6332 22.7231 84.5761 23.0921C85.7296 23.5531 86.5768 24.0921 87.1218 24.7101C87.6648 25.3261 87.9358 26.0971 87.9358 27.0171Z"
      fill="white"
    />
    <path
      d="M95.0369 22.7531H92.6695V27.4121C92.6695 28.5971 93.0866 29.1891 93.9228 29.1891C94.3066 29.1891 94.6249 29.1561 94.8768 29.0901L94.9362 30.7091C94.5131 30.8661 93.956 30.9451 93.2659 30.9451C92.4177 30.9451 91.7548 30.6881 91.2763 30.1751C90.7998 29.6611 90.56 28.7991 90.56 27.5881V22.7511H89.1497V21.1511H90.56V19.3941L92.6695 18.7621V21.1511H95.0369V22.7531Z"
      fill="white"
    />
    <path
      d="M105.718 25.8721C105.718 27.3471 105.293 28.5581 104.445 29.5051C103.555 30.4801 102.375 30.9661 100.903 30.9661C99.4845 30.9661 98.3552 30.4991 97.513 29.5651C96.6708 28.6311 96.2498 27.4521 96.2498 26.0311C96.2498 24.5441 96.6829 23.3261 97.5523 22.3791C98.4197 21.4311 99.5903 20.9571 101.062 20.9571C102.481 20.9571 103.622 21.4241 104.483 22.3591C105.307 23.2661 105.718 24.4371 105.718 25.8721ZM103.49 25.9411C103.49 25.0561 103.3 24.2971 102.914 23.6641C102.463 22.8981 101.82 22.5161 100.986 22.5161C100.122 22.5161 99.4664 22.8991 99.0161 23.6641C98.6303 24.2981 98.4399 25.0691 98.4399 25.9811C98.4399 26.8661 98.6303 27.6251 99.0161 28.2571C99.4805 29.0231 100.129 29.4051 100.966 29.4051C101.786 29.4051 102.43 29.0151 102.895 28.2371C103.291 27.5921 103.49 26.8251 103.49 25.9411Z"
      fill="white"
    />
    <path
      d="M112.7 23.0281C112.487 22.9891 112.261 22.9691 112.023 22.9691C111.267 22.9691 110.683 23.2521 110.272 23.8191C109.914 24.3191 109.735 24.9511 109.735 25.7141V30.7491H107.588L107.608 24.1751C107.608 23.0691 107.581 22.0621 107.528 21.1541H109.399L109.477 22.9901H109.537C109.763 22.3591 110.121 21.8511 110.611 21.4701C111.089 21.1271 111.606 20.9561 112.163 20.9561C112.361 20.9561 112.541 20.9701 112.7 20.9951V23.0281Z"
      fill="white"
    />
    <path
      d="M122.306 25.4971C122.306 25.8791 122.28 26.2011 122.227 26.4641H115.784C115.809 27.4121 116.12 28.1371 116.718 28.6371C117.261 29.0841 117.964 29.3081 118.826 29.3081C119.78 29.3081 120.65 29.1571 121.433 28.8541L121.77 30.3341C120.855 30.7301 119.775 30.9271 118.529 30.9271C117.03 30.9271 115.853 30.4891 114.997 29.6141C114.143 28.7391 113.714 27.5641 113.714 26.0901C113.714 24.6431 114.112 23.4381 114.909 22.4771C115.743 21.4511 116.871 20.9381 118.289 20.9381C119.682 20.9381 120.737 21.4511 121.453 22.4771C122.02 23.2921 122.306 24.3001 122.306 25.4971ZM120.257 24.9441C120.272 24.3121 120.132 23.7661 119.84 23.3051C119.469 22.7121 118.897 22.4161 118.129 22.4161C117.427 22.4161 116.855 22.7051 116.419 23.2851C116.062 23.7461 115.849 24.2991 115.784 24.9431H120.257V24.9441Z"
      fill="white"
    />
  </svg>
);

export const PlayStoreIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="136"
    height="40"
    viewBox="0 0 136 40"
    fill="none"
  >
    <rect width="136" height="40" rx="8" fill="#1A1A1A" />
    <path
      d="M10.1137 7.29789C9.81774 7.59993 9.64648 8.07017 9.64648 8.67914V30.401C9.64648 31.01 9.81774 31.4802 10.1137 31.7822L10.1867 31.8485L22.671 19.6813V19.394L10.1867 7.22668L10.1137 7.29789Z"
      fill="url(#paint0_linear_5630_12410)"
    />
    <path
      d="M26.8277 23.7391L22.6709 19.6813V19.394L26.8328 15.3361L26.9259 15.3889L31.8547 18.1232C33.2613 18.8992 33.2613 20.176 31.8547 20.9569L26.9259 23.6863L26.8277 23.7391V23.7391Z"
      fill="url(#paint1_linear_5630_12410)"
    />
    <path
      d="M26.9259 23.6863L22.6709 19.5376L10.1135 31.7822C10.5807 32.2611 11.3426 32.3188 12.2089 31.84L26.9259 23.6863"
      fill="url(#paint2_linear_5630_12410)"
    />
    <path
      d="M26.9259 15.389L12.2089 7.2353C11.3426 6.76138 10.5807 6.81908 10.1135 7.29791L22.6709 19.5376L26.9259 15.389Z"
      fill="url(#paint3_linear_5630_12410)"
    />
    <path
      d="M47.3702 9.95488C47.3702 10.775 47.1183 11.4319 46.6222 11.9218C46.0517 12.5025 45.3088 12.7947 44.3983 12.7947C43.5282 12.7947 42.7852 12.4976 42.1757 11.912C41.565 11.3177 41.2603 10.5884 41.2603 9.71547C41.2603 8.84252 41.565 8.11322 42.1757 7.52388C42.7852 6.93332 43.5282 6.6362 44.3983 6.6362C44.8315 6.6362 45.2445 6.72337 45.6387 6.88544C46.0316 7.04873 46.3514 7.26973 46.5831 7.5423L46.0568 8.06042C45.6525 7.5951 45.1023 7.3655 44.3983 7.3655C43.7637 7.3655 43.2134 7.58159 42.7462 8.01745C42.284 8.45454 42.0523 9.02054 42.0523 9.71547C42.0523 10.4104 42.284 10.9813 42.7462 11.4184C43.2134 11.8493 43.7637 12.0703 44.3983 12.0703C45.072 12.0703 45.6387 11.8493 46.0857 11.4135C46.3804 11.125 46.5479 10.7272 46.592 10.2189H44.3983V9.5092H47.3248C47.3601 9.66267 47.3702 9.81123 47.3702 9.95488V9.95488Z"
      fill="white"
      stroke="white"
      strokeWidth="0.16"
      strokeMiterlimit="10"
    />
    <path
      d="M52.013 7.49442H49.2641V9.36064H51.7423V10.0703H49.2641V11.9365H52.013V12.6597H48.4858V6.77126H52.013V7.49442Z"
      fill="white"
      stroke="white"
      strokeWidth="0.16"
      strokeMiterlimit="10"
    />
    <path
      d="M55.2896 12.6597H54.5113V7.49442H52.8252V6.77126H56.977V7.49442H55.2896V12.6597V12.6597Z"
      fill="white"
      stroke="white"
      strokeWidth="0.16"
      strokeMiterlimit="10"
    />
    <path
      d="M59.9817 12.6597V6.77126H60.7587V12.6597H59.9817Z"
      fill="white"
      stroke="white"
      strokeWidth="0.16"
      strokeMiterlimit="10"
    />
    <path
      d="M64.2026 12.6597H63.4307V7.49442H61.7383V6.77126H65.8951V7.49442H64.2026V12.6597Z"
      fill="white"
      stroke="white"
      strokeWidth="0.16"
      strokeMiterlimit="10"
    />
    <path
      d="M73.7555 11.9021C73.1599 12.4976 72.4219 12.7947 71.5417 12.7947C70.6565 12.7947 69.9185 12.4976 69.3229 11.9021C68.7285 11.3079 68.4326 10.5786 68.4326 9.71547C68.4326 8.85234 68.7285 8.12304 69.3229 7.52879C69.9185 6.93332 70.6565 6.6362 71.5417 6.6362C72.4169 6.6362 73.1548 6.93332 73.7505 7.53371C74.3499 8.13286 74.6458 8.85725 74.6458 9.71547C74.6458 10.5786 74.3499 11.3079 73.7555 11.9021ZM69.8984 11.4086C70.3467 11.8493 70.8919 12.0703 71.5417 12.0703C72.1865 12.0703 72.7368 11.8493 73.18 11.4086C73.6271 10.9678 73.8537 10.4018 73.8537 9.71547C73.8537 9.02914 73.6271 8.46313 73.18 8.02236C72.7368 7.58159 72.1865 7.36059 71.5417 7.36059C70.8919 7.36059 70.3467 7.58159 69.8984 8.02236C69.4514 8.46313 69.2247 9.02914 69.2247 9.71547C69.2247 10.4018 69.4514 10.9678 69.8984 11.4086V11.4086Z"
      fill="white"
      stroke="white"
      strokeWidth="0.16"
      strokeMiterlimit="10"
    />
    <path
      d="M75.7375 12.6597V6.77126H76.682L79.6186 11.3509H79.6526L79.6186 10.2189V6.77126H80.3956V12.6597H79.5846L76.5095 7.85416H76.4755L76.5095 8.99108V12.6597H75.7375V12.6597Z"
      fill="white"
      stroke="white"
      strokeWidth="0.16"
      strokeMiterlimit="10"
    />
    <path
      d="M68.2413 21.2587C65.8751 21.2587 63.9421 23.0145 63.9421 25.4369C63.9421 27.8396 65.8751 29.6138 68.2413 29.6138C70.6124 29.6138 72.5454 27.8396 72.5454 25.4369C72.5454 23.0145 70.6124 21.2587 68.2413 21.2587ZM68.2413 27.9685C66.943 27.9685 65.826 26.9237 65.826 25.4369C65.826 23.9304 66.943 22.904 68.2413 22.904C69.5395 22.904 70.6615 23.9304 70.6615 25.4369C70.6615 26.9237 69.5395 27.9685 68.2413 27.9685V27.9685ZM58.861 21.2587C56.4898 21.2587 54.5619 23.0145 54.5619 25.4369C54.5619 27.8396 56.4898 29.6138 58.861 29.6138C61.231 29.6138 63.1601 27.8396 63.1601 25.4369C63.1601 23.0145 61.231 21.2587 58.861 21.2587ZM58.861 27.9685C57.5615 27.9685 56.4407 26.9237 56.4407 25.4369C56.4407 23.9304 57.5615 22.904 58.861 22.904C60.1593 22.904 61.2763 23.9304 61.2763 25.4369C61.2763 26.9237 60.1593 27.9685 58.861 27.9685ZM47.699 22.5393V24.3147H52.0472C51.92 25.3067 51.58 26.036 51.0587 26.5443C50.424 27.1582 49.4355 27.8396 47.699 27.8396C45.023 27.8396 42.9276 25.734 42.9276 23.125C42.9276 20.5159 45.023 18.4103 47.699 18.4103C49.1458 18.4103 50.1986 18.9616 50.9756 19.6761L52.2587 18.425C51.172 17.4133 49.7264 16.6362 47.699 16.6362C44.0295 16.6362 40.9456 19.5472 40.9456 23.125C40.9456 26.7027 44.0295 29.6138 47.699 29.6138C49.6823 29.6138 51.172 28.9802 52.3431 27.7917C53.5432 26.6217 53.9172 24.9764 53.9172 23.648C53.9172 23.2355 53.8819 22.8561 53.819 22.5393H47.699ZM93.3421 23.9156C92.9882 22.9813 91.8964 21.2587 89.6726 21.2587C87.4689 21.2587 85.6341 22.9518 85.6341 25.4369C85.6341 27.777 87.45 29.6138 89.8841 29.6138C91.8524 29.6138 92.9882 28.4437 93.4554 27.7623L91.9947 26.8132C91.5073 27.5081 90.8437 27.9685 89.8841 27.9685C88.9309 27.9685 88.2471 27.5425 87.8089 26.7027L93.5398 24.3908L93.3421 23.9156V23.9156ZM87.4991 25.3067C87.45 23.6959 88.7823 22.8708 89.7368 22.8708C90.4848 22.8708 91.1195 23.2355 91.331 23.7573L87.4991 25.3067V25.3067ZM82.8411 29.3596H84.7249V17.0818H82.8411V29.3596ZM79.7559 22.1894H79.6929C79.2698 21.7007 78.4627 21.2587 77.4401 21.2587C75.2944 21.2587 73.3324 23.0955 73.3324 25.4504C73.3324 27.7917 75.2944 29.6138 77.4401 29.6138C78.4627 29.6138 79.2698 29.1681 79.6929 28.6647H79.7559V29.2638C79.7559 30.8612 78.8807 31.7194 77.4691 31.7194C76.3181 31.7194 75.6041 30.9091 75.3095 30.2277L73.6712 30.8943C74.1434 32.0018 75.3938 33.3646 77.4691 33.3646C79.6778 33.3646 81.5415 32.0976 81.5415 29.0146V21.5129H79.7559V22.1894V22.1894ZM77.6013 27.9685C76.303 27.9685 75.2163 26.909 75.2163 25.4504C75.2163 23.9783 76.303 22.904 77.6013 22.904C78.8807 22.904 79.8894 23.9783 79.8894 25.4504C79.8894 26.909 78.8807 27.9685 77.6013 27.9685V27.9685ZM102.162 17.0818H97.6563V29.3596H99.5351V24.7076H102.162C104.248 24.7076 106.295 23.2355 106.295 20.8941C106.295 18.5539 104.243 17.0818 102.162 17.0818V17.0818ZM102.211 22.9997H99.5351V18.7897H102.211C103.614 18.7897 104.415 19.9254 104.415 20.8941C104.415 21.8444 103.614 22.9997 102.211 22.9997ZM113.825 21.2354C112.468 21.2354 111.056 21.8198 110.476 23.1151L112.143 23.7966C112.502 23.1151 113.162 22.8941 113.859 22.8941C114.834 22.8941 115.822 23.4651 115.837 24.4731V24.602C115.497 24.4104 114.77 24.1268 113.874 24.1268C112.079 24.1268 110.249 25.0906 110.249 26.8893C110.249 28.5345 111.72 29.5941 113.373 29.5941C114.637 29.5941 115.335 29.0379 115.773 28.3909H115.837V29.34H117.652V24.6302C117.652 22.4534 115.985 21.2354 113.825 21.2354ZM113.598 27.9636C112.984 27.9636 112.128 27.6665 112.128 26.9237C112.128 25.9734 113.196 25.6088 114.12 25.6088C114.947 25.6088 115.335 25.7868 115.837 26.0213C115.69 27.1582 114.686 27.9636 113.598 27.9636V27.9636ZM124.263 21.5043L122.104 26.8267H122.039L119.807 21.5043H117.78L121.135 28.9422L119.221 33.081H121.184L126.354 21.5043H124.263V21.5043ZM107.327 29.3596H109.211V17.0818H107.327V29.3596Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_5630_12410"
        x1="21.5625"
        y1="30.6272"
        x2="5.08378"
        y2="13.7259"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00A0FF" />
        <stop offset="0.0066" stopColor="#00A1FF" />
        <stop offset="0.2601" stopColor="#00BEFF" />
        <stop offset="0.5122" stopColor="#00D2FF" />
        <stop offset="0.7604" stopColor="#00DFFF" />
        <stop offset="1" stopColor="#00E3FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_5630_12410"
        x1="33.6863"
        y1="19.5362"
        x2="9.31016"
        y2="19.5362"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFE000" />
        <stop offset="0.4087" stopColor="#FFBD00" />
        <stop offset="0.7754" stopColor="#FFA500" />
        <stop offset="1" stopColor="#FF9C00" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_5630_12410"
        x1="24.6121"
        y1="17.2823"
        x2="2.26559"
        y2="-5.63719"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF3A44" />
        <stop offset="1" stopColor="#C31162" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_5630_12410"
        x1="6.95258"
        y1="39.009"
        x2="16.9313"
        y2="28.7745"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#32A071" />
        <stop offset="0.0685" stopColor="#2DA771" />
        <stop offset="0.4762" stopColor="#15CF74" />
        <stop offset="0.8009" stopColor="#06E775" />
        <stop offset="1" stopColor="#00F076" />
      </linearGradient>
    </defs>
  </svg>
);

export const Rewind10SecondsIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none">
    <path
      fill="#fff"
      d="M12.44 21.685v-5.794l-1.69.529v-1.213l3.032-.87v7.348h-1.343ZM18.89 21.84c-.57 0-1.068-.151-1.495-.455-.427-.311-.76-.747-.997-1.306-.23-.567-.345-1.234-.345-2 0-.761.115-1.424.345-1.991.238-.567.57-1.002.997-1.306.427-.311.926-.466 1.495-.466.57 0 1.068.155 1.495.466.427.304.756.74.987 1.306.237.567.356 1.23.356 1.99 0 .767-.119 1.434-.356 2-.23.56-.56.996-.987 1.307-.427.304-.925.456-1.495.456Zm0-1.222c.448 0 .804-.225 1.068-.674.271-.45.407-1.071.407-1.866 0-.795-.136-1.416-.407-1.866-.264-.449-.62-.673-1.068-.673-.447 0-.807.224-1.078.673-.264.45-.396 1.071-.396 1.866 0 .795.132 1.417.396 1.866.271.449.63.674 1.078.674Z"
    />
    <path
      fill="#fff"
      d="m19.22 3.064-2.278 2.603a18.88 18.88 0 0 1 2.924.735c1.516.514 3.017 1.247 4.072 2.195a12.289 12.289 0 0 1 3.865 6.964 12.436 12.436 0 0 1-1.186 7.909 12.096 12.096 0 0 1-5.729 5.47 11.792 11.792 0 0 1-7.82.689 11.985 11.985 0 0 1-6.566-4.385A12.384 12.384 0 0 1 4 17.66a.791.791 0 0 1 .791-.792c.433.004.78.365.777.806a10.765 10.765 0 0 0 2.174 6.593 10.42 10.42 0 0 0 5.708 3.812 10.25 10.25 0 0 0 6.799-.6 10.515 10.515 0 0 0 4.98-4.754 10.812 10.812 0 0 0 1.03-6.875 10.683 10.683 0 0 0-3.36-6.054c-.83-.747-2.11-1.397-3.53-1.878-.686-.232-1.389-.42-2.065-.56l1.915 2.24-1.182 1.05-3.28-3.836a.81.81 0 0 1 .005-1.057L18.051 2l1.17 1.064Zm-4.568-.058-2.572 3.26 2.576 3.007-1.181 1.051-3.008-3.512a.81.81 0 0 1-.02-1.026l2.983-3.781 1.222 1.001Z"
    />
  </svg>
);

export const Forward10SecondsIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none">
    <path
      fill="#fff"
      d="M11.961 21.685v-5.794l-1.688.529v-1.213l3.031-.87v7.348h-1.343ZM18.413 21.84c-.57 0-1.068-.151-1.495-.455-.428-.311-.76-.747-.997-1.306-.23-.567-.346-1.234-.346-2 0-.761.115-1.424.346-1.991.237-.567.57-1.002.997-1.306.427-.311.925-.466 1.495-.466.57 0 1.067.155 1.495.466.427.304.756.74.986 1.306.238.567.356 1.23.356 1.99 0 .767-.119 1.434-.356 2-.23.56-.56.996-.986 1.307-.428.304-.926.456-1.495.456Zm0-1.222c.447 0 .803-.225 1.067-.674.272-.45.407-1.071.407-1.866 0-.795-.135-1.416-.407-1.866-.264-.449-.62-.673-1.067-.673-.448 0-.807.224-1.078.673-.265.45-.397 1.071-.397 1.866 0 .795.132 1.417.397 1.866.27.449.63.674 1.078.674Z"
    />
    <path
      fill="#fff"
      d="m12.78 3.064 2.28 2.603c-.948.157-1.954.406-2.925.735-1.516.514-3.017 1.247-4.072 2.195a12.29 12.29 0 0 0-3.865 6.964 12.436 12.436 0 0 0 1.185 7.909 12.096 12.096 0 0 0 5.73 5.47 11.792 11.792 0 0 0 7.82.689 11.985 11.985 0 0 0 6.566-4.385A12.383 12.383 0 0 0 28 17.66a.791.791 0 0 0-.791-.792.792.792 0 0 0-.777.806 10.765 10.765 0 0 1-2.174 6.593 10.42 10.42 0 0 1-5.708 3.812 10.25 10.25 0 0 1-6.799-.6 10.515 10.515 0 0 1-4.98-4.754 10.811 10.811 0 0 1-1.03-6.875A10.683 10.683 0 0 1 9.1 9.796c.83-.747 2.11-1.397 3.53-1.878.686-.232 1.389-.42 2.065-.56l-1.915 2.24 1.182 1.05 3.28-3.836a.81.81 0 0 0-.005-1.057L13.95 2l-1.17 1.064Zm4.569-.058 2.572 3.26-2.576 3.007 1.181 1.051 3.009-3.512a.81.81 0 0 0 .02-1.026L18.57 2.005l-1.222 1.001Z"
    />
  </svg>
);

export const PauseIconWithShadow = ({
  type = "light",
}: {
  type?: "light" | "dark";
}) => (
  <svg
    width="32"
    height="37.02"
    viewBox="0 0 32 37.02"
    fill="none"
    // Offset needed to align icon with button due to drop shadow effect
    className="translate-x-[2px] translate-y-[3px]"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.192 24.345h-3.748V7.948h3.748zm-7.496 0h-3.748V7.948h3.748z"
      fill={type === "light" ? "#fff" : "#000"}
    />
  </svg>
);

export const VolumeHighIcon = ({ className }: { className?: string }) => (
  <svg
    width="30"
    height="29"
    viewBox="0 0 30 29"
    fill="none"
    className={`translate-y-0.5 ${className || ""}`}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_14_393)">
      <path
        d="M14 5L9 9H5V15H9L14 19V5Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.07 4.92993C23.9447 6.80521 24.9979 9.34829 24.9979 11.9999C24.9979 14.6516 23.9447 17.1947 22.07 19.0699M18.54 8.45993C19.4774 9.39757 20.004 10.6691 20.004 11.9949C20.004 13.3208 19.4774 14.5923 18.54 15.5299"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_14_393"
        x="-1"
        y="0"
        width="32"
        height="32"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_14_393"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_14_393"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const MuteIcon = ({ className }: { className?: string }) => (
  <svg
    width="31"
    height="28"
    viewBox="0 0 31 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g filter="url(#filter0_d_14_398)">
      <path
        d="M14 5L9 9H5V15H9L14 19V5Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26 9L20 15"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 9L26 15"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_14_398"
        x="-1"
        y="0"
        width="32"
        height="32"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_14_398"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_14_398"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const EpisodesIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_5562_355)">
      <rect
        x="4.48633"
        y="4.75"
        width="25.863"
        height="17.6541"
        rx="1.25"
        stroke="white"
        strokeWidth="1.5"
      />
      <g filter="url(#filter0_d_5562_355)">
        <path
          d="M1 10.3484V23C1 24.6569 2.34315 26 4 26H26.2834"
          stroke="white"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_5562_355"
        x="-3.5"
        y="6.34839"
        width="33.7832"
        height="24.1516"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_5562_355"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_5562_355"
          result="shape"
        />
      </filter>
      <clipPath id="clip0_5562_355">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const SubtitlesIcon = ({
  type = "light",
  width = 16,
  height = 17,
}: {
  type?: "light" | "dark";
  width?: number;
  height?: number;
}) => (
  <svg
    width={width}
    height={height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#a)">
      <mask
        id="b"
        style={{
          maskType: "alpha",
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={width}
        height={height}
      >
        <path fill="#D9D9D9" d="M0 .5h16v16H0z" />
      </mask>
      <g mask="url(#b)">
        <path
          d="M4 11.167h5.333V9.833H4zm6.666 0H12V9.833h-1.334zM4 8.5h1.333V7.167H4zm2.666 0H12V7.167H6.666zm-4 5.333q-.55 0-.941-.391a1.28 1.28 0 0 1-.392-.942v-8q0-.55.392-.942.391-.39.941-.391h10.667q.55 0 .942.391.39.392.391.942v8q0 .55-.391.942a1.28 1.28 0 0 1-.942.391zm0-1.333h10.667v-8H2.666z"
          fill={type === "light" ? "#fff" : "#000"}
        />
      </g>
    </g>
    <defs>
      <clipPath id="a">
        <path fill={type === "light" ? "#fff" : "#000"} d="M0 .5h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const PlaybackSpeedIcon = ({
  type = "light",
  width = 24,
  height = 24,
}: {
  type?: "light" | "dark";
  width?: number;
  height?: number;
}) => {
  const stroke = type === "light" ? "#fff" : "#000";
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2"
        stroke={stroke}
        strokeWidth={1.5}
        strokeLinecap="round"
      />
      <path
        opacity={0.5}
        d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.97715 2 12.5 2"
        stroke={stroke}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeDasharray="4 3"
      />
      <path
        d="M15.4137 10.941C16.1954 11.4026 16.1954 12.5974 15.4137 13.059L10.6935 15.8458C9.93371 16.2944 9 15.7105 9 14.7868L9 9.21316C9 8.28947 9.93371 7.70561 10.6935 8.15419L15.4137 10.941Z"
        stroke={stroke}
        strokeWidth={1.5}
      />
    </svg>
  );
};

export const MinimizeIcon = ({
  type = "light",
}: {
  type?: "light" | "dark";
}) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="a"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={24}
      height={24}
    >
      <path fill="#D9D9D9" d="M0 0h24v24H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        d="M6 21v-3H3v-2h5v5zm10 0v-5h5v2h-3v3zM3 8V6h3V3h2v5zm13 0V3h2v3h3v2z"
        fill={type === "light" ? "#fff" : "#000"}
      />
    </g>
  </svg>
);

export const MaximizeIcon = ({ type }: { type?: "light" | "dark" }) => {
  const stroke = type === "light" ? "#fff" : "#000";
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="a"
        style={{
          maskType: "alpha",
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={23}
        height={23}
      >
        <path d="M22.79.202H.202V22.79H22.79z" fill="#D9D9D9" />
      </mask>
      <g mask="url(#a)">
        <path
          d="M3.025 19.966V15.26h1.883v2.824H7.73v1.882zm12.236 0v-1.882h2.823v-2.823h1.883v4.705zM3.025 7.731V3.025h4.706v1.883H4.908V7.73zm15.06 0V4.908H15.26V3.025h4.706v4.706z"
          fill={stroke}
        />
      </g>
    </svg>
  );
};

export const AppPlayerQualityIcon = ({
  width = 16,
  height = 16,
  type = "light",
}: {
  width?: number;
  height?: number;
  type?: "light" | "dark";
}) => {
  const fillColor = type === "light" ? "#fff" : "#000";
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.667 4.833h-4a.504.504 0 0 1-.5-.5c0-.273.226-.5.5-.5h4c.273 0 .5.227.5.5 0 .274-.227.5-.5.5M4 4.833H1.333a.504.504 0 0 1-.5-.5c0-.273.227-.5.5-.5H4c.273 0 .5.227.5.5 0 .274-.227.5-.5.5"
        fill={fillColor}
      />
      <path
        d="M6.667 7.167a2.84 2.84 0 0 1-2.834-2.834A2.84 2.84 0 0 1 6.667 1.5 2.84 2.84 0 0 1 9.5 4.333a2.84 2.84 0 0 1-2.833 2.834m0-4.667a1.832 1.832 0 1 0 0 3.667 1.832 1.832 0 1 0 0-3.667m8 9.667H12a.504.504 0 0 1-.5-.5c0-.274.227-.5.5-.5h2.667c.273 0 .5.226.5.5 0 .273-.227.5-.5.5m-9.334 0h-4a.504.504 0 0 1-.5-.5c0-.274.227-.5.5-.5h4c.274 0 .5.226.5.5 0 .273-.226.5-.5.5"
        fill={fillColor}
      />
      <path
        d="M9.333 14.5A2.84 2.84 0 0 1 6.5 11.667a2.84 2.84 0 0 1 2.833-2.834 2.84 2.84 0 0 1 2.834 2.834A2.84 2.84 0 0 1 9.333 14.5m0-4.667a1.832 1.832 0 1 0 0 3.667 1.832 1.832 0 1 0 0-3.667"
        fill={fillColor}
      />
    </svg>
  );
};

export const AppNextEpisodeIcon = ({
  width = 16,
  height = 16,
  type = "light",
}: {
  width?: number;
  height?: number;
  type?: "light" | "dark";
}) => {
  const fillColor = type === "light" ? "#fff" : "#000";
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.207 13.393c-.38 0-.754-.1-1.1-.3a2.17 2.17 0 0 1-1.1-1.906v-6.38a2.19 2.19 0 0 1 1.1-1.907c.693-.4 1.513-.4 2.2 0l5.526 3.187a2.19 2.19 0 0 1 1.1 1.906 2.19 2.19 0 0 1-1.1 1.907l-5.526 3.187c-.347.206-.72.306-1.1.306m0-9.786a1.2 1.2 0 0 0-1.2 1.2v6.38c0 .433.226.82.6 1.04.373.213.826.22 1.2 0l5.526-3.187a1.2 1.2 0 0 0 0-2.08L4.807 3.773a1.2 1.2 0 0 0-.6-.166m9.287 9.013a.504.504 0 0 1-.5-.5V3.88c0-.273.226-.5.5-.5.273 0 .5.227.5.5v8.24a.5.5 0 0 1-.5.5"
        fill={fillColor}
      />
    </svg>
  );
};

export const AppSubtitlesIcon = ({
  width = 16,
  height = 16,
  type = "light",
}: {
  width?: number;
  height?: number;
  type?: "light" | "dark";
}) => {
  const fillColor = type === "light" ? "#fff" : "#000";
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 15.167H6C2.38 15.167.833 13.62.833 10V6C.833 2.38 2.38.833 6 .833h4c3.62 0 5.167 1.547 5.167 5.167v4c0 3.62-1.547 5.167-5.167 5.167M6 1.833C2.927 1.833 1.833 2.927 1.833 6v4c0 3.073 1.094 4.167 4.167 4.167h4c3.073 0 4.167-1.094 4.167-4.167V6c0-3.073-1.094-4.167-4.167-4.167z"
        fill={fillColor}
      />
      <path
        d="M11.667 11.887h-1.234a.504.504 0 0 1-.5-.5c0-.274.227-.5.5-.5h1.234c.273 0 .5.226.5.5 0 .273-.227.5-.5.5m-3.02 0H4.333a.504.504 0 0 1-.5-.5c0-.274.227-.5.5-.5h4.314a.5.5 0 1 1 0 1m3.02-2.507H7.98a.504.504 0 0 1-.5-.5c0-.273.227-.5.5-.5h3.687c.273 0 .5.227.5.5s-.227.5-.5.5m-5.487 0H4.333a.504.504 0 0 1-.5-.5c0-.273.227-.5.5-.5H6.18c.273 0 .5.227.5.5s-.227.5-.5.5"
        fill={fillColor}
      />
    </svg>
  );
};

export const AppPlaybackSpeedIcon = ({
  width = 16,
  height = 16,
  type = "light",
}: {
  width?: number;
  height?: number;
  type?: "light" | "dark";
}) => {
  const fillColor = type === "light" ? "#fff" : "#000";
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.713 13.213a.5.5 0 0 1-.353-.146.503.503 0 0 1 0-.707c2.407-2.407 2.407-6.32 0-8.72a.503.503 0 0 1 0-.707.503.503 0 0 1 .707 0c2.793 2.794 2.793 7.34 0 10.134-.1.1-.227.146-.354.146m-9.426 0a.5.5 0 0 1-.354-.146C.14 10.273.14 5.727 2.933 2.933a.503.503 0 0 1 .707 0 .503.503 0 0 1 0 .707c-2.407 2.407-2.407 6.32 0 8.72a.503.503 0 0 1 0 .707c-.1.1-.227.146-.353.146M8 15.14a7.3 7.3 0 0 1-2.367-.4.503.503 0 0 1 .334-.947c.64.22 1.32.34 2.04.34.713 0 1.4-.12 2.033-.34a.51.51 0 0 1 .64.307.503.503 0 0 1-.307.64c-.746.26-1.54.4-2.373.4m2.2-12.913a.5.5 0 0 1-.167-.027 6.27 6.27 0 0 0-4.073 0 .51.51 0 0 1-.64-.307.503.503 0 0 1 .307-.64C6.367.993 7.167.86 7.993.86s1.627.133 2.367.393c.26.094.4.38.307.64a.49.49 0 0 1-.467.334m-3.16 8.946c-.293 0-.573-.073-.82-.213-.573-.333-.893-.987-.893-1.84V6.887c0-.854.313-1.507.893-1.84.574-.334 1.3-.28 2.04.146l1.934 1.114c.74.426 1.146 1.026 1.146 1.693s-.406 1.267-1.146 1.693L8.26 10.807c-.42.246-.84.366-1.22.366m0-5.346a.6.6 0 0 0-.32.08c-.246.146-.393.5-.393.973v2.233c0 .474.14.834.393.974.247.14.627.086 1.04-.147l1.934-1.113c.413-.24.646-.54.646-.827s-.233-.587-.646-.827L7.76 6.06c-.266-.153-.513-.233-.72-.233"
        fill={fillColor}
      />
    </svg>
  );
};

export const PlayerQualityIcon = ({
  width = 32,
  height = 32,
  type = "light",
}: {
  width?: number;
  height?: number;
  type?: "light" | "dark";
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      fill={type === "light" ? "#fff" : "#000"}
      d="M14.75 16.5h1.5V15H17c.283 0 .52-.096.712-.287A.968.968 0 0 0 18 14v-4a.967.967 0 0 0-.288-.713A.968.968 0 0 0 17 9h-3a.968.968 0 0 0-.713.287A.967.967 0 0 0 13 10v4c0 .283.096.52.287.713.192.191.43.287.713.287h.75v1.5ZM6 15h1.5v-2h2v2H11V9H9.5v2.5h-2V9H6v6Zm8.5-1.5v-3h2v3h-2ZM4 20c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 2 18V6c0-.55.196-1.02.587-1.412A1.926 1.926 0 0 1 4 4h16c.55 0 1.02.196 1.413.588.391.391.587.862.587 1.412v12c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 20 20H4Zm0-2h16V6H4v12Z"
    />
  </svg>
);

export const PlayIconWithShadow = ({
  type = "light",
}: {
  type?: "light" | "dark";
}) => (
  <svg
    width="32"
    height="37.12"
    viewBox="0 0 32 37.12"
    fill="none"
    // Offset needed to align icon with button due to drop shadow effect
    className="translate-x-[4px] translate-y-[4px]"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.907 15.808a0.64 0.64 0 0 1 -0.019 1.042L8.682 23.846A0.64 0.64 0 0 1 7.68 23.318v-14.579a0.64 0.64 0 0 1 1.021 -0.513z"
      fill={type === "light" ? "#fff" : "#000"}
    />
  </svg>
);

export const RecentIcon = () => {
  return (
    <svg
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="recent-icon"
    >
      <path
        d="M7.875 3.667H7v2.916l2.496 1.482.42-.706-2.041-1.213zM7.583.75A5.25 5.25 0 0 0 2.333 6H.583l2.31 2.35L5.25 6H3.5a4.083 4.083 0 1 1 4.083 4.083 4.05 4.05 0 0 1-2.882-1.201l-.828.828a5.2 5.2 0 0 0 3.71 1.54 5.25 5.25 0 1 0 0-10.5"
        fill="#CBCBCB"
      />
    </svg>
  );
};

export const NowPlayingIcon = () => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        y="3.125"
        width="2.5"
        height="3.75"
        rx="1.25"
        fill="url(#paint0_linear_9556_5842)"
      />
      <rect
        x="3.75"
        width="2.5"
        height="10"
        rx="1.25"
        fill="url(#paint1_linear_9556_5842)"
      />
      <rect
        x="7.5"
        y="3.125"
        width="2.5"
        height="3.75"
        rx="1.25"
        fill="url(#paint2_linear_9556_5842)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_9556_5842"
          x1="0"
          y1="5"
          x2="2.5"
          y2="5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#EFA73F" />
          <stop offset="1" stop-color="#BA5D07" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_9556_5842"
          x1="3.75"
          y1="5"
          x2="6.25"
          y2="5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#EFA73F" />
          <stop offset="1" stop-color="#BA5D07" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_9556_5842"
          x1="7.5"
          y1="5"
          x2="10"
          y2="5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#EFA73F" />
          <stop offset="1" stop-color="#BA5D07" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const Popcorn = () => {
  return (
    <svg
      width="151"
      height="80"
      viewBox="0 0 151 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse cx="75.5" cy="62.5" rx="75.5" ry="13.5" fill="#313131" />
      <path
        d="M135.05 52.735c-.016.364 2.152.693 2.85 1.121.699.43 1.389 1.456 2.465 1.217 1.076-.24.771-2.08-.811-2.678-1.758-.663-4.464-.453-4.504.34m.578 5.09c-.53.075-1.156 1.002-1.421 1.147-.273.144-1.228.812-1.228.812s.618 1.53.233 2.438c-.386.908-1.421 1.336-1.156 1.6.273.265 1.421.12 1.806-.024.385-.145 1.116-.429 1.116-.429s3.436 1.376 4.006-.05c.811-2.03-2.505-2.438-2.577-2.702s1.228-1.027 1.036-1.865c-.201-.832-1.124-1.027-1.815-.927m-9.891 1.147c-1.212.339-1.308 1.41-1.308 1.41s-2.698.524-2.923 1.601c-.232 1.077 1.574 1.785 3.075 2.01 1.927.288 6.094.293 6.046-2.369-.041-2.01-4.119-2.867-4.89-2.652m-13.736 10.56c.016.333 3.179.109 4.464 1.166 1.388 1.142 1.132 2.034 1.003 3.206-.128 1.216-.739 2.039-.193 2.293.675.32 5.379.514 5.773-1.147.233-.982-1.309-1.241-1.309-1.241s.345-1.002-1.268-1.556c-1.116-.379-1.847-.403-1.927-.573-.032-.075 6.342-2.637 2.465-4.637-4.039-2.079-7.387 1.72-7.387 1.72s-1.661.125-1.621.768"
        fill="#FCE193"
      />
      <g clipPath="url(#a)">
        <path
          d="m81.017 12.943 4.123-4.075s2.051-.168 2.705 1.275c.744 1.644-.132 3.225-.132 3.225l-5.34 2.494zm-.14 53.744 3.109-3.525 3.852 2.369s1.105 1.225-.07 3.344c-.897 1.618-2.635 2.018-3.17 1.83-.536-.18-3.72-4.018-3.72-4.018"
          fill="#B40E1C"
        />
        <path
          d="m81.761 14.219.591-1.97s1.036-.224 1.954.2c.953.445.848 1.313.848 1.313s1.133-2.093 3.908-1.18c2.774.912 2.162 3.705 2.162 3.705s1.76-.062 2.844 1.22c1.085 1.274.271 2.25.271 2.25s3.512-.988 5.139 1.455c1.39 2.088.07 3.525.07 3.525s2.349.844 2.398 3.157c.035 1.73-.709 2.256-.709 2.256s1.356.606 1.961 1.581c.611.975.521 1.556.521 1.556s1.683-.443 3.059.025c2.434.825 2.976 3.1 2.504 4.8-.647 2.332-2.441 2.044-2.441 2.044s.883 1.181.744 2.275c-.132 1.094-.939 1.669-.939 1.669s2.49.762 2.49 3.312c0 2.557-1.69 3.282-2.976 3.407s-2.803-.644-2.803-.644-.159.369-1.133.481c-.737.088-1.391-.169-1.391-.169s1.03 1.175 0 3.52c-1.703 3.887-6.306 3.074-6.306 3.074s.146 1.125-.257 1.975a3.5 3.5 0 0 1-1.231 1.425s2.016.219 2.03 2.494c.014 2.375-4.936 4.319-6.355 3.894-1.418-.425-1.759-1.582-1.759-1.582s-.334 1.057-1.76 1.45c-1.682.47-3.469.082-3.469.082S70.532 50.33 70.601 50.149c.07-.18-1.69-20.612-1.69-20.612z"
          fill="#FFB91F"
        />
        <path
          d="M78.298 21.774c.146 0 .751.188 1.015.556.327.457.362 1.138.362 1.138s.396-.75 1.703-1.169c.849-.275 1.766.063 1.766.063s-.104-1.982 1.565-2.438 1.884.263 1.884.263 4.735-.794 4.819 2.537c.11 4.556-6.335 3.775-6.335 3.775s0 .65-.396 1.044c-.396.387-.8.519-.8.519s1.426.85 1.085 2.862c-.8 4.75-5.973 2.538-5.973 2.538s2.677-.882 2.789-2.407c.11-1.53-1.05-3.418-1.05-3.418s-.397 2.893-2.1 3.675c-1.704.78-4.02.718-4.02.718s-1.883-5.793-1.668-5.925c.209-.137 5.354-4.33 5.354-4.33"
          fill="#FCE193"
        />
        <path
          d="M83.944 25.381c.202-.419-.946-1.594-1.8-1.619-.856-.025-1.948.625-2.024 1.4-.077.77.806 1.538 1.661 1.538.432 0 1.913-.8 2.163-1.319"
          fill="#E17A2C"
        />
        <path
          d="M93.54 28.919s.5-3.12-2.365-3.057c-3.796.082-3.233 3.925-3.434 3.957-.202.03-1.495.187-1.495.187s.194 1.519-.772 2.987c-.967 1.47-2.1 2.1-2.1 2.1s1.565.3 2.232.72c.668.418 1.168.868 1.168.868s.835 0 1.502-.212c.48-.15.73-.507.73-.507s1.78 3.375 4.735 1.675c3.33-1.919.237-4.975.237-4.975s1.933-1.2 1.467-2.693c-.466-1.5-1.905-1.05-1.905-1.05m-12.495 7.668s3.435-.9 4.401.781-.132 2.788.07 2.844c.201.056 3.302 2.669 3.233 4.913-.098 3.325-2.448 4.087-2.698 4.162-1.196.369-3.136-.118-3.136-.118s2.17 1.256 1.968 3.056-1.801 2-1.801 2-1.37 1.987-2.67 1.893c-1.3-.087-2.267-1.35-2.267-1.35l-3.33-3.056 1.265-3.294s1.669-.45 2.698-.45c1.036 0 1.863.088 1.863.088s-.535-.9-.73-1.525c-.201-.631-.236-1.95-.236-1.95s.841-.05 1.8-1.319c2.1-2.781-.43-6.675-.43-6.675"
          fill="#FCE193"
        />
        <path
          d="M76.414 37.906s4.116-1.019 4.2 1.919c.097 3.506-3.366 4.012-5.299 4.137-1.933.119-4.902-4.525-4.797-4.706.097-.181 3.073-4.531 3.073-4.531s1.07-.332 2.023.4c1.009.762.8 2.78.8 2.78m1.898 19.506s.932-1.019 2.698-.719 1.863 1.525 1.863 1.525 1.6-.93 2.636-.48 1.265 1.168 1.23 3.474-.73 3.475-1.634 4.225c-.806.675-3.268.238-3.268.238s-4.568-3.413-4.463-3.807c.104-.387.938-4.456.938-4.456M90.21 47.85s-.834 1.2-1.467 1.587c-.633.388-1.836.9-1.836.9s3.254.25 4.84 1.456c1.73 1.32 1.661 3.038 1.661 3.07 0 .324 2.698.868 4.13-.388 1.794-1.575 1.169-4.282.897-4.257-.27.025-1.564.988-4.568.363-2.74-.581-3.657-2.731-3.657-2.731m-.633-8.388c-.27.481.626 1.338 1.002 2.069.43.837.597 1.919 1.063 1.95s2.135-1.169 1.203-2.906-2.969-1.65-3.268-1.113m-1.613-25.825c-1.696-.15-2.225 1.406-2.225 1.406s-1.564-.193-2.468.363c-.73.45-1.634 1.381-1.537 1.769s1.398 1.618 1.502 1.618c.097 0 3.831-.068 5.166-.78 1.877-.988 2.573-4.107-.438-4.376m2.246 5.456c0 .42 1.064.838 1.467 1.082.403.237 1.064 1.137 1.064 1.137s1.064-1.381.097-2.25c-.96-.869-2.628-.6-2.628.031m3.031 3.35s.098.838.07 1.32c-.035.48-.202 1.287-.202 1.287s.87.118 1.502.987c.633.869.431 1.675.431 1.675s1.203.181 1.732.869c.535.687.535 1.106.535 1.106s1.822.638 2.503-.3c1.933-2.669-1.947-4.037-2.03-4.494-.063-.337 1.238-1.512.236-2.8-1.71-2.187-4.776.35-4.776.35m4.367 8.45s-.201.72-.563 1.257-1.001 1.35-1.001 1.35l.132 3.956s1.265.869 1.835 2.125c.466 1.025.501 2.219.501 2.219s3.254.112 4.102-2.307c1.064-3.056-2.398-4.075-2.398-4.075s1.126-.9 1.098-1.95c-.069-2.33-3.706-2.575-3.706-2.575"
          fill="#FCE193"
        />
        <path
          d="M98.775 35.356c0-.362-2.03-2.487-2.232-2.544-.201-.062-.535.507-.73.57-.201.062.265 3.893.431 4.105.167.207 2.531-1.318 2.531-2.13m-6.862-4.787c-.397.018-2.997 1.768-3.101 2.306s2.1 2.313 2.6 1.8c.236-.237-.035-2.006-.035-2.006s1.467-.031 1.697-.181c.236-.157-.5-1.95-1.161-1.92"
          fill="#E17A2C"
        />
        <path
          d="M103.309 34.912c-.014.456 1.863.869 2.468 1.406.605.538 1.203 1.825 2.135 1.525s.667-2.606-.703-3.356c-1.522-.831-3.866-.569-3.9.425m.5 6.381c-.459.094-1.001 1.257-1.23 1.438-.237.181-1.064 1.019-1.064 1.019s.535 1.918.201 3.056c-.333 1.137-1.23 1.675-1.001 2.006.236.331 1.231.15 1.565-.031s.966-.538.966-.538 2.976 1.725 3.47-.062c.702-2.544-2.17-3.056-2.232-3.388-.063-.33 1.063-1.287.897-2.337-.174-1.044-.974-1.288-1.572-1.163m-8.566 1.438c-1.05.425-1.133 1.769-1.133 1.769s-2.337.656-2.531 2.006c-.202 1.35 1.363 2.237 2.663 2.519 1.668.362 5.277.368 5.235-2.97-.034-2.518-3.567-3.593-4.234-3.324M83.346 55.968c.014.42 2.754.138 3.866 1.463 1.203 1.431.98 2.55.87 4.019-.112 1.525-.64 2.556-.168 2.875.584.4 4.659.643 5-1.438.201-1.231-1.134-1.556-1.134-1.556s.3-1.256-1.098-1.95c-.967-.475-1.6-.506-1.669-.719-.028-.094 5.493-3.306 2.135-5.812-3.498-2.607-6.397 2.156-6.397 2.156s-1.44.156-1.405.962"
          fill="#FCE193"
        />
        <path
          d="M98.872 46.475c-.125-.169-3.365-.238-3.4-.088s-1.168 2.038-.869 2.307c.3.268 1.836.268 2.83-.213.64-.3 1.877-1.406 1.44-2.006m4.068-3.988c-.341-.025-2.135.388-2.197.87-.111.8.834 2.274 1.168 2.424s1.3-.119 1.634-1.319c.327-1.187-.139-1.943-.605-1.975m-20.296.3c-.5.42.862 1.87.598 2.394-.3.6-2.03 0-2.232.656-.202.657 2.17 1.975 3.198 1.825.431-.062 1.002-.837 1.335-1.675.334-.837.563-1.975.202-2.487-.362-.513-2.204-1.463-3.101-.713m-2.399 17.525s2.135-.062 3.198.45c1.064.507.897 1.8.633 2.007-.264.206-2.197.93-2.197.93l-2.9-1.524z"
          fill="#E17A2C"
        />
        <path
          d="m69.343 39.593 2.6-5.975.292-.169c.522-.3 1.224-4.237 1.224-4.237l.076-.35 1.175-4.906.265-.138c.577-.306 2.141-4.256 2.141-4.256l1.669-3.713.271-.1c.883-.331 2.413-2.844 2.288-2.9l.619-1.119c.66.294 1.752 1.226 1.119 2.638-.55 1.231-2.447 2.638-3.198 2.944l-1.162 2.018c.348.494.696 1.426.202 2.7-.723 1.85-2.315 2.338-2.976 2.72l-.973 4.062c.389.431 1.043 1.343.82 2.562-.39 2.131-1.759 2.65-2.454 3.094l-.445 4.681c.716.469 2.232 1.663 2.517 3.519.27 1.738-.397 3.006-1.064 3.519l1.676 4.475c.646.375 2.475 1.669 2.885 3.694.383 1.887-.681 3.368-1.161 4.05l1.704 2.987c.597.319 2.46 1.35 2.996 2.925.66 1.969-.723 3.231-.772 3.288l-1.029-.844c.028-.025-2.565-4.132-2.586-4.144l-1.69-.881-.25-3.45.278-.313c.014-.012-1.259-6.331-1.28-6.343l-.243-.12-2.113-5.65.326-.274c.042-.038-3.747-5.994-3.747-5.994"
          fill="#DFDFDF"
        />
        <path
          d="M79.612 67.324c-.014-.143 1.822-1.318 1.113-2.85-.716-1.53-3.644-2.993-3.644-2.993l-.834-4.77s1.446-.643.89-2.424-2.99-3.381-2.83-3.419c.16-.037-1.321-5.25-1.321-5.25s1.28-1.031.772-2.869c-.529-1.9-3.122-2.93-3.122-2.93l1.307-5.92s1.891-1.012 2.128-2.543c.236-1.532-.876-2.525-.876-2.525l1.196-4.42s2.058-.674 2.774-2.6c.716-1.924-.195-2.85-.195-2.85l2.163-2.862s1.543-.843 2.377-2.45c.835-1.6-.625-2.062-.625-2.062l-46.69 9.975-8.643 19.1 9.185 18.856c-.007.013 44.924 8.238 44.875 7.806"
          fill="#fff"
        />
        <path
          d="m81.017 12.943.049-.012c.91-.175 2.975-.632 3.914-1.713 1.217-1.406.167-2.35.167-2.35L34.959 19.712l-1.126 2.65zm-3.769 7.031s3.136-.168 3.88-2.393c.591-1.77-1.432-1.844-1.432-1.844L32.839 24.53l-1.502 3.356zm-3.622 9.438s3.372-.906 3.657-3.213-1.87-2.075-1.87-2.075l-45.098 5.97-1.516 3.355zm.952 7.331c.355-2.531-2.475-2.881-2.475-2.881l-44.68 2.619-1.878 4.2 45.32-.75s3.338-.532 3.713-3.188m-.174 14.531s3.547.132 2.65-2.718c-.89-2.85-3.86-3.163-3.86-3.163l-45.716-.712 1.745 3.537zm3.804 10.57s2.781-.12 2.218-2.563c-.584-2.563-3.456-2.588-3.456-2.588L31.128 52.2l1.676 3.413zm6.66 6.524c-1.119-2.1-4.122-2.281-4.122-2.281L34.424 58.93l1.655 3.356 48.56 8.444c0-.007 1.21-.525.23-2.363"
          fill="#ED3D23"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M112 0v80H23V0z" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const CustomerSupportIcon = () => {
  return (
    <svg
      width="19"
      height="21"
      viewBox="0 0 19 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.714 13.757c.237.066.462.13.688.192.871.238 1.745.46 2.604.736a7.6 7.6 0 0 1 1.488.638c.458.267.752.648.935 1.14.202.546-.525.895-.525.895l-.573.381s-2.91 1.91-2.864 2.1c-2.1.382-1.734.764-4.725.764-3.038 0-5.394-.954-5.394-.954l-1.91-1.337-1.717-1.336s.108-.356.337-.847c.185-.395.509-.638.869-.849.6-.352 1.257-.562 1.92-.753.874-.252 1.752-.487 2.63-.73.134-.038.138-.037.126.103-.035.401-.044.8.043 1.197.083.373.268.703.435 1.04.41.823.895 1.596 1.539 2.26q.45.46.992.808c.059.037.089.012.13-.013a5.6 5.6 0 0 0 1.443-1.327 10.5 10.5 0 0 0 1.416-2.474c.206-.504.181-1.038.123-1.568z"
        fill="#fff"
      />
      <path
        d="M5.397 7.462c-.008-.22-.045-.413-.068-.608-.094-.812-.122-1.624.066-2.425.242-1.031.889-1.753 1.799-2.254.634-.349 1.319-.527 2.039-.58.972-.071 1.902.079 2.777.515 1.1.548 1.8 1.412 2.006 2.641.085.507.065 1.02.04 1.531q-.028.543-.112 1.081c-.007.046-.013.079.054.084a.56.56 0 0 1 .504.48c.086.688-.06 1.316-.513 1.86-.208.251-.342.55-.489.837-.353.692-.749 1.356-1.283 1.926-.523.56-1.136.968-1.897 1.125-.962.198-1.83-.03-2.611-.605-.613-.45-1.064-1.045-1.456-1.688-.25-.411-.456-.845-.667-1.275-.029-.057-.054-.087-.129-.072-.546.11-.962-.055-1.245-.539A5.5 5.5 0 0 1 3.62 7.91a1.5 1.5 0 0 1 .007-.638.9.9 0 0 1 .487-.642c.064-.033.077-.069.077-.13 0-.534.013-1.07.003-1.604-.025-1.219.503-2.19 1.362-2.998C6.495 1.012 7.633.545 8.91.407c1.077-.115 2.124 0 3.135.396.956.373 1.756.957 2.36 1.797.33.46.549.974.713 1.513q.01.038.01.079c.013.802.027 1.604.013 2.406a2 2 0 0 1-.017.206c-.02.145-.137.238-.29.235-.148-.003-.251-.096-.263-.245-.042-.576-.037-1.152-.05-1.729-.009-.442-.035-.88-.232-1.294-.658-1.385-1.735-2.26-3.215-2.626C9.663.796 8.293.93 7.01 1.64a4.4 4.4 0 0 0-2.017 2.288c-.175.443-.183.916-.19 1.387-.007.355-.002.71-.004 1.065 0 .056 0 .103.065.129a.42.42 0 0 1 .229.257l.225.574q.022.073.08.123m.901.982c-.044-.021-.048-.063-.064-.096-.072-.147-.138-.297-.234-.431a.5.5 0 0 0-.179-.175c-.076-.04-.15-.028-.223.024s-.065.114-.045.184l.056.186c.137.415.28.83.409 1.247a.9.9 0 0 0 .197.379 5.04 5.04 0 0 0 2.13 1.332c.08.026.127.013.18-.06.14-.197.316-.338.582-.322.175.011.351 0 .527.01.151.01.312.016.428.132.156.154.252.343.196.567-.062.239-.196.425-.461.467a2.6 2.6 0 0 1-1.065-.039c-.663-.172-1.306-.388-1.892-.754-.035-.023-.073-.048-.13-.045q.177.34.397.654c.55.788 1.232 1.372 2.253 1.411.321.013.644.035.96-.027.705-.14 1.252-.536 1.694-1.09.441-.556.754-1.18 1.047-1.82.108-.234.203-.478.38-.673.265-.289.433-.654.48-1.043.026-.2.033-.406-.085-.587-.13-.2-.278-.21-.434-.032-.12.137-.195.299-.273.46-.023.048-.033.106-.092.148l.014-.092c.104-.589.23-1.174.275-1.772.007-.094 0-.134-.11-.138a12 12 0 0 1-2.1-.24c-.944-.207-1.813-.573-2.58-1.169-.239-.185-.456-.395-.686-.589-.042-.035-.081-.066-.143-.048-.3.084-.587.189-.83.391a3.1 3.1 0 0 0-.734.9 1 1 0 0 0-.125.481q-.013.591.088 1.174zm4.593 6.52-.05.076q-.223.328-.504.606c-.085.087-.092.163-.046.272.192.468.376.94.566 1.409.026.065.017.108-.023.163-.311.426-.697.776-1.112 1.097-.027.021-.047.044-.088.013-.418-.327-.837-.652-1.128-1.11a.16.16 0 0 1-.017-.164c.198-.487.39-.976.587-1.463.029-.07.023-.114-.037-.166a3.2 3.2 0 0 1-.55-.655c-.039-.06-.036-.095.01-.147.159-.182.34-.339.512-.508a.1.1 0 0 1 .082-.03h1.157c.026 0 .053.008.073.025q.305.237.54.541z"
        fill="#fff"
      />
    </svg>
  );
};
export const PlusIcon = ({
  color = "#fff",
  width = 21,
  height = 21,
}: {
  color?: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#a)">
        <path
          d="M18 10.5H3M10.5 3v15"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M2.167 2.167h16.667v16.667H2.167z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const MyListCheckedIcon = ({
  color = "#fff",
  width = 21,
  height = 21,
}: {
  color?: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#a)">
        <path
          d="m2.4 13.04 6.4 6.16L21.6 6"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill={color} d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ProfileFilled = ({
  color = "#fff",
  width = 20,
  height = 20,
}: {
  color?: string;
  width?: number;
  height?: number;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#a)" fillRule="evenodd" clipRule="evenodd" fill={color}>
      <path d="M13.333 7.5a3.333 3.333 0 1 1-6.667 0 3.333 3.333 0 0 1 6.667 0m-1.667 0a1.667 1.667 0 1 1-3.333 0 1.667 1.667 0 0 1 3.333 0" />
      <path d="M10 .833a9.167 9.167 0 1 0 0 18.334A9.167 9.167 0 0 0 10 .833M2.5 10c0 1.742.594 3.345 1.59 4.618a7.5 7.5 0 0 1 5.964-2.951 7.48 7.48 0 0 1 5.91 2.881A7.5 7.5 0 1 0 2.5 10m7.5 7.5a7.47 7.47 0 0 1-4.727-1.677 5.83 5.83 0 0 1 4.781-2.49 5.83 5.83 0 0 1 4.74 2.434A7.47 7.47 0 0 1 10 17.5" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill={color} d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const ProfileNoFill = ({
  color = "#979797",
  width = 20,
  height = 20,
}: {
  color?: string;
  width?: number;
  height?: number;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#a)" fillRule="evenodd" clipRule="evenodd" fill={color}>
      <path d="M13.333 7.5a3.333 3.333 0 1 1-6.667 0 3.333 3.333 0 0 1 6.667 0m-1.667 0a1.667 1.667 0 1 1-3.333 0 1.667 1.667 0 0 1 3.333 0" />
      <path d="M10 .833a9.167 9.167 0 1 0 0 18.334A9.167 9.167 0 0 0 10 .833M2.5 10c0 1.742.594 3.345 1.59 4.618a7.5 7.5 0 0 1 5.964-2.951 7.48 7.48 0 0 1 5.91 2.881A7.5 7.5 0 1 0 2.5 10m7.5 7.5a7.47 7.47 0 0 1-4.727-1.677 5.83 5.83 0 0 1 4.781-2.49 5.83 5.83 0 0 1 4.74 2.434A7.47 7.47 0 0 1 10 17.5" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill={color} d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const HomeFilled = ({
  color = "#fff",
  width = 20,
  height = 20,
}: {
  color?: string;
  width?: number;
  height?: number;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.305 22a2 2 0 0 1-2-2V9.766a2 2 0 0 1 .887-1.661l8-5.36a2 2 0 0 1 2.226 0l8 5.36a2 2 0 0 1 .887 1.661V20a2 2 0 0 1-2 2h-3.418a2 2 0 0 1-2-2v-4.087a2 2 0 0 0-2-2h-1.165a2 2 0 0 0-2 2V20a2 2 0 0 1-2 2z"
      fill={color}
    />
  </svg>
);

export const HomeNoFill = ({
  color = "#979797",
  width = 20,
  height = 20,
}: {
  color?: string;
  width?: number;
  height?: number;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.581 3.327a1.3 1.3 0 0 1 1.447 0l8 5.36a1.3 1.3 0 0 1 .577 1.08V20a1.3 1.3 0 0 1-1.3 1.3h-3.417a1.3 1.3 0 0 1-1.3-1.3v-4.087a2.7 2.7 0 0 0-2.7-2.7h-1.166a2.7 2.7 0 0 0-2.7 2.7V20a1.3 1.3 0 0 1-1.3 1.3H4.305a1.3 1.3 0 0 1-1.3-1.3V9.767a1.3 1.3 0 0 1 .576-1.08z"
      stroke={color}
      strokeWidth={1.4}
    />
  </svg>
);

export const MyListFilled = ({
  color = "#fff",
  width = 20,
  height = 20,
}: {
  color?: string;
  width?: number;
  height?: number;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#a)">
      <path
        d="M17.5 10h-15M10 2.5v15"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill={color} d="M1.667 1.667h16.667v16.667H1.667z" />
      </clipPath>
    </defs>
  </svg>
);

export const MyListNoFill = ({
  color = "#979797",
  width = 20,
  height = 20,
}: {
  color?: string;
  width?: number;
  height?: number;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#a)">
      <path
        d="M17.5 10h-15M10 2.5v15"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill={color} d="M1.667 1.667h16.667v16.667H1.667z" />
      </clipPath>
    </defs>
  </svg>
);

export const SearchFilled = ({
  color = "#fff",
  width = 20,
  height = 20,
}: {
  color?: string;
  width?: number;
  height?: number;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.167 15.833a6.667 6.667 0 1 0 0-13.333 6.667 6.667 0 0 0 0 13.333M17.5 17.5l-3.625-3.625"
      stroke={color}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SearchNoFill = ({
  color = "#979797",
  width = 20,
  height = 20,
}: {
  color?: string;
  width?: number;
  height?: number;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.167 15.833a6.667 6.667 0 1 0 0-13.333 6.667 6.667 0 0 0 0 13.333M17.5 17.5l-3.625-3.625"
      stroke={color}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SettingsFilled = ({
  color = "#fff",
  width = 20,
  height = 20,
}: {
  color?: string;
  width?: number;
  height?: number;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.374 4.426c.046.366.294.667.615.848a4 4 0 0 1 .277.168c.297.19.667.237.991.1l1.919-.81a1 1 0 0 1 1.256.422L22.56 8.85a1 1 0 0 1-.26 1.295l-1.823 1.387a.74.74 0 0 0-.269.597v.742c0 .227.064.462.245.6l1.819 1.384a1 1 0 0 1 .26 1.295l-2.128 3.694a1 1 0 0 1-1.258.42l-1.89-.804a1.09 1.09 0 0 0-.994.095 8 8 0 0 1-.294.172c-.314.174-.548.473-.592.828l-.258 2.069a1 1 0 0 1-.992.876H9.874a1 1 0 0 1-.993-.877l-.254-2.049c-.046-.365-.294-.667-.615-.848a4 4 0 0 1-.279-.17 1.07 1.07 0 0 0-.987-.099l-1.922.811a1 1 0 0 1-1.255-.422l-2.13-3.696a1 1 0 0 1 .26-1.295l1.824-1.388c.182-.139.268-.366.268-.595v-.743a.74.74 0 0 0-.269-.597L1.7 10.145a1 1 0 0 1-.261-1.295l2.13-3.696a1 1 0 0 1 1.255-.423l1.92.811c.325.137.693.09.992-.096a7 7 0 0 1 .295-.174c.314-.173.549-.472.593-.828l.257-2.067a1 1 0 0 1 .993-.877h4.253a1 1 0 0 1 .992.876zM12.18 8.5q-1.761 0-2.971 1.23T8 12.7t1.21 2.97 2.97 1.23q1.731 0 2.955-1.23t1.223-2.97-1.223-2.97T12.18 8.5"
      fill={color}
    />
  </svg>
);

export const SettingsNoFill = ({
  color = "#979797",
  width = 20,
  height = 20,
}: {
  color?: string;
  width?: number;
  height?: number;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.873 2.3h4.254a.2.2 0 0 1 .198.176l.255 2.05c.084.676.532 1.173 1.018 1.446l.104.061.133.083a1.87 1.87 0 0 0 1.733.162l1.92-.81a.2.2 0 0 1 .25.085l2.13 3.697a.2.2 0 0 1-.053.259l-1.82 1.386c-.43.327-.586.82-.586 1.234v.742c0 .34.092.88.56 1.236l1.82 1.384a.2.2 0 0 1 .052.259l-2.13 3.695a.2.2 0 0 1-.251.084l-1.89-.804a1.89 1.89 0 0 0-1.73.15l-.14.085-.118.066c-.497.274-.919.777-1 1.43l-.257 2.068a.2.2 0 0 1-.198.176H9.873a.2.2 0 0 1-.198-.176l-.255-2.05c-.084-.676-.532-1.173-1.017-1.446l-.102-.06-.137-.085a1.87 1.87 0 0 0-1.73-.162l-1.921.81a.2.2 0 0 1-.251-.084l-2.13-3.697a.2.2 0 0 1 .053-.259l1.822-1.386c.43-.327.584-.82.584-1.233v-.743c0-.413-.155-.907-.585-1.234L2.185 9.509a.2.2 0 0 1-.053-.259l2.13-3.697a.2.2 0 0 1 .25-.084l1.922.81c.592.25 1.233.15 1.723-.153q.07-.044.143-.086l.118-.066c.497-.274.919-.777 1-1.43l.257-2.068a.2.2 0 0 1 .198-.176Z"
      stroke={color}
      strokeWidth={1.6}
    />
    <path
      d="M12.179 9.3c.94 0 1.722.325 2.388.994.667.67.992 1.457.992 2.406s-.325 1.736-.992 2.406c-.666.669-1.447.994-2.388.994-.965 0-1.747-.328-2.399-.99-.657-.67-.98-1.458-.98-2.41s.32-1.74.978-2.409c.653-.663 1.436-.991 2.4-.991Z"
      stroke={color}
      strokeWidth={1.6}
    />
  </svg>
);

export const CircularInfoIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.333 10a8.333 8.333 0 1 1-16.666 0 8.333 8.333 0 0 1 16.666 0M10 16.667a6.667 6.667 0 1 0 0-13.334 6.667 6.667 0 0 0 0 13.334"
        fill="#c60c0c"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 11.667a.833.833 0 0 1-.834-.833V6.667a.833.833 0 1 1 1.667 0v4.167a.833.833 0 0 1-.833.833"
        fill="#c60c0c"
      />
      <path
        d="M9.167 13.333a.833.833 0 1 1 1.666 0 .833.833 0 0 1-1.667 0"
        fill="#c60c0c"
      />
    </svg>
  );
};

export const BackspaceIcon = ({
  fillColor = "#fff",
}: {
  fillColor?: "#fff" | "#000";
}) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="a"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={24}
      height={24}
    >
      <path fill="#D9D9D9" d="M0 0h24v24H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        d="m11.4 16 2.6-2.6 2.6 2.6 1.4-1.4-2.6-2.6L18 9.4 16.6 8 14 10.6 11.4 8 10 9.4l2.6 2.6-2.6 2.6zM9 20a1.99 1.99 0 0 1-1.6-.8L2 12l5.4-7.2q.275-.375.7-.587Q8.525 4 9 4h11q.824 0 1.413.588Q22 5.175 22 6v12q0 .824-.587 1.413A1.93 1.93 0 0 1 20 20zm-4.5-8L9 18h11V6H9z"
        fill={fillColor}
      />
    </g>
  </svg>
);

export const SpaceIcon = ({
  fillColor = "#fff",
}: {
  fillColor?: "#fff" | "#000";
}) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M3 9v5h18V9h2v7H1V9z" fill={fillColor} />
  </svg>
);

export const TimerIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none">
    <path
      fill="#fff"
      d="M12 22.75c-5.24 0-9.5-4.26-9.5-9.5s4.26-9.5 9.5-9.5 9.5 4.26 9.5 9.5-4.26 9.5-9.5 9.5zm0-17.5c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8z"
    />
    <path
      fill="#fff"
      d="M12 13.75c-.41 0-.75-.34-.75-.75V8c0-.41.34-.75.75-.75s.75.34.75.75v5c0 .41-.34.75-.75.75zm3-11H9c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h6c.41 0 .75.34.75.75s-.34.75-.75.75z"
    />
  </svg>
);

export const NextEpisodeIcon = ({
  type = "light",
  width = 17,
  height = 17,
}: {
  type?: "light" | "dark";
  width?: number;
  height?: number;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.214 3.502a1.286 1.286 0 0 1 2.019-1.056l7.145 4.96a1.286 1.286 0 0 1 .007 2.108L4.24 14.548a1.286 1.286 0 0 1-2.026-1.051z"
      fill={type === "dark" ? "#000" : "#fff"}
    />
    <rect
      x={13.167}
      y={2.213}
      width={2}
      height={12.573}
      rx={1}
      fill={type === "dark" ? "#000" : "#fff"}
    />
  </svg>
);
export const ContentCultureIcon = ({
  type = "light",
  width = 24,
  height = 24,
}: {
  type?: "light" | "default";
  width?: number;
  height?: number;
}) => {
  const color = type === "light" ? "#CACACA" : "#fff";
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8m-7 7a7 7 0 0 1 7-7c1.635 0 2.809.06 4 1"
        stroke={color}
        strokeWidth={1.6}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="m11 17.929-.618-.33A.7.7 0 0 0 11 18.63zm0 0 .618.328a.7.7 0 0 0-.003-.662zm0 0 .615-.336A.7.7 0 0 0 11 17.23zm11 0v-.7a.7.7 0 0 0-.582.311zm0 0v.7a.7.7 0 0 0 .596-1.067zm0 0-.593-.372a.7.7 0 0 0-.003.738zm0 0 .593.372A.7.7 0 0 0 22 17.229zm0 0-.586.383a.7.7 0 0 0 .586.316zm-11 0v.7a.7.7 0 0 0 .617-.37zm0 0v-.7a.7.7 0 0 0-.615 1.033zm0 0 .618.328zl-.618-.328zm0 0v-.7zv.7zm0 0-.614.335c1.242 2.278 3.178 3.964 5.455 4.191 2.317.232 4.696-1.07 6.741-4.138L22 17.929l-.582-.389c-1.883 2.824-3.826 3.684-5.438 3.522-1.651-.165-3.25-1.425-4.365-3.469zm11 0v-.7zv.7zm0 0-.596.366.009.015.002.003v.001l-.002-.004-.01-.015zl.596-.367-.009-.015-.002-.003v-.001l.002.005.01.014zm0 0 .593.372-.01.014-.002.005v-.002l.003-.003.009-.015zl-.593-.372.01-.014.002-.004q0 .003-.003.004l-.009.014zm0 0v-.7zv.7zm-11 0 .617.33c1.118-2.09 2.719-3.372 4.365-3.54 1.604-.163 3.546.708 5.432 3.593l.586-.384.586-.383c-2.043-3.124-4.422-4.456-6.746-4.219-2.283.233-4.217 1.955-5.457 4.272zm0 0v-.7zv.7zm0 0-.615.333zl.615-.333z"
        fill={color}
      />
      <circle cx={16.5} cy={17.929} r={1.857} stroke="#CACACA" />
    </svg>
  );
};
export const AboutUsIcon = ({
  type = "default",
}: {
  type?: "default" | "white";
}) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 11.5v5m0-8.99.01-.011M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18"
      stroke={type === "white" ? "#fff" : "#CACACA"}
      strokeWidth={1.6}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const CareerIcon = ({
  type = "default",
}: {
  type?: "default" | "white";
}) => {
  const color = type === "white" ? "#fff" : "#CACACA";
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.4 7.556H4.8c-.994 0-1.8.795-1.8 1.777v8.89C3 19.203 3.806 20 4.8 20h14.4c.994 0 1.8-.796 1.8-1.778V9.333c0-.982-.806-1.777-1.8-1.777h-3.6m-7.2 0V4.533c0-.294.242-.533.54-.533h6.12c.298 0 .54.239.54.533v3.023m-7.2 0h7.2"
        stroke={color}
        strokeWidth={1.6}
      />
      <path
        d="m3 11 8.594 3.82a1 1 0 0 0 .812 0L21 11"
        stroke={color}
        strokeWidth={1.6}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const PrivacyPolicyIcon = ({
  type = "default",
}: {
  type?: "default" | "white";
}) => {
  const color = type === "white" ? "#fff" : "#CACACA";
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.997 10V6.186a.5.5 0 0 0-.165-.36L14.88 3.149A.6.6 0 0 0 14.482 3H3.56c-.31 0-.562.228-.562.51v15.98c0 .282.251.51.562.51h8.013M5.997 9.5h7m-7-2.5h3.5m-3.5 5h2.625"
        stroke={color}
        strokeWidth={1.4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.997 3v3.4a.6.6 0 0 0 .6.6h3.4m-.007 6.062 2.56.654a.59.59 0 0 1 .446.589c-.172 5.804-3.5 6.695-3.5 6.695s-3.327-.891-3.5-6.695a.59.59 0 0 1 .447-.589l2.56-.654c.324-.083.663-.083.987 0"
        stroke={color}
        strokeWidth={1.4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ContactUsIcon = ({
  type = "default",
}: {
  type?: "default" | "white";
}) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 10h8m-8 4h4m0 7a9 9 0 1 0-7.796-4.5l-.754 4.05 4.05-.754A8.96 8.96 0 0 0 12 21"
      stroke={type === "white" ? "#fff" : "#CACACA"}
      strokeWidth={1.6}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const TermOfUseIcon = ({
  type = "default",
}: {
  type?: "default" | "white";
}) => {
  const color = type === "white" ? "#fff" : "#CACACA";
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.5 21.26H4.25a.5.5 0 0 1-.5-.5V2.5a.5.5 0 0 1 .5-.5h11.938a.5.5 0 0 1 .5.5v6.907M6.625 5.704h7.188M6.625 8.667h7.188M6.625 11.63h4.313m-4.313 5.926H9.5"
        stroke={color}
        strokeWidth={1.4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.406 12.33c1.181 0 2.175.993 2.175 2.263s-.994 2.262-2.175 2.262c-1.182 0-2.175-.992-2.175-2.262s.993-2.263 2.175-2.263Z"
        stroke={color}
        strokeWidth={1.4}
      />
      <path
        d="M13.813 22v-1.963a1 1 0 0 1 1-1H20a1 1 0 0 1 1 1V22"
        stroke={color}
        strokeWidth={1.4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const RefundPolicyIcon = ({
  type = "default",
}: {
  type?: "default" | "white";
}) => {
  const color = type === "white" ? "#fff" : "#CACACA";
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_2846_4154)">
        <path
          d="M21.6601 9.41202C23.0881 14.746 19.9231 20.23 14.5881 21.659C9.99008 22.891 5.28408 20.709 3.15508 16.669C3.03149 16.4343 3.0062 16.1601 3.08478 15.9067C3.16336 15.6534 3.33937 15.4416 3.57408 15.318C3.8088 15.1944 4.083 15.1691 4.33636 15.2477C4.58972 15.3263 4.80149 15.5023 4.92508 15.737C5.78201 17.3595 7.17063 18.6381 8.85818 19.3585C10.5457 20.0789 12.4296 20.1973 14.1941 19.6938C15.9586 19.1904 17.4963 18.0957 18.5496 16.5932C19.603 15.0908 20.1078 13.2719 19.9795 11.4415C19.8512 9.61115 19.0976 7.88049 17.845 6.53966C16.5924 5.19883 14.917 4.32933 13.0995 4.07693C11.2821 3.82452 9.43313 4.20455 7.86256 5.1533C6.292 6.10205 5.09531 7.56186 4.47308 9.28802L5.53008 9.05302C6.71608 8.78802 7.39208 10.359 6.38408 11.038L3.71108 12.84C2.99308 13.323 1.99108 12.824 1.99808 11.922C2.01607 9.73412 2.75092 7.61245 4.09003 5.88212C5.42914 4.15179 7.29864 2.90825 9.41208 2.34202C14.7461 0.910022 20.2301 4.07602 21.6591 9.41002"
          fill={color}
        />
        <path
          d="M13.9868 17C13.7669 17 13.5729 16.8563 13.5086 16.646L13.2218 15.7068C13.1128 15.3258 12.9767 14.99 12.8132 14.6992C12.6498 14.3985 12.4319 14.1629 12.1595 13.9925C11.8872 13.812 11.524 13.7218 11.07 13.7218H9.5C9.22386 13.7218 9 13.4979 9 13.2218V12.9586C9 12.6825 9.22386 12.4586 9.5 12.4586H10.7977C11.0246 12.4586 11.2789 12.4486 11.5603 12.4286C11.8418 12.3985 12.1096 12.3233 12.3638 12.203C12.6271 12.0727 12.8405 11.8622 13.0039 11.5714C13.1764 11.2707 13.2626 10.8496 13.2626 10.3083C13.2626 9.90727 13.2082 9.58145 13.0992 9.33083C12.9903 9.07018 12.8495 8.86967 12.677 8.72932C12.5045 8.58897 12.3139 8.48872 12.1051 8.42857C11.9053 8.36842 11.7101 8.33333 11.5195 8.32331C11.4395 8.3189 11.3649 8.31545 11.2955 8.31298C11.1635 8.30828 11.0564 8.2012 11.0564 8.06913C11.0564 7.93592 11.1653 7.82839 11.2985 7.83L13.1746 7.85277C13.3744 7.85519 13.535 8.01781 13.535 8.21757C13.535 8.37854 13.6424 8.5168 13.7889 8.58352C13.9737 8.66772 14.1297 8.77647 14.2568 8.90977C14.4475 9.10025 14.5837 9.3208 14.6654 9.57143C14.7562 9.81203 14.8016 10.0777 14.8016 10.3684C14.8016 10.6992 14.7562 11.01 14.6654 11.3008C14.5746 11.5915 14.4293 11.8571 14.2296 12.0977C14.0389 12.3283 13.7847 12.5138 13.4669 12.6541C13.1824 12.7835 12.8401 12.8703 12.4399 12.9145C12.3815 12.9209 12.3366 12.9698 12.3366 13.0286C12.3366 13.0886 12.3833 13.138 12.443 13.1436C12.8757 13.1839 13.2306 13.3015 13.5078 13.4962C13.8074 13.7068 14.0525 13.9875 14.2432 14.3383C14.4429 14.6792 14.6154 15.0752 14.7607 15.5263L15.0321 16.3422C15.1398 16.6659 14.8988 17 14.5577 17H13.9868ZM9.49624 10.8947C9.22217 10.8947 9 10.6726 9 10.3985C9 10.1244 9.22217 9.90226 9.49624 9.90226H15.5038C15.7778 9.90226 16 10.1244 16 10.3985C16 10.6726 15.7778 10.8947 15.5038 10.8947H9.49624ZM9.5 8.30827C9.22386 8.30827 9 8.08441 9 7.80827V7.5C9 7.22386 9.22386 7 9.5 7H15.5C15.7761 7 16 7.22386 16 7.5V7.80827C16 8.08441 15.7761 8.30827 15.5 8.30827H9.5Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_2846_4154">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const MoviesInactiveIcon = ({
  color = "#fff",
  width = 24,
  height = 24,
}: {
  color?: string;
  width?: number;
  height?: number;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 22.75H9c-5.43 0-7.75-2.32-7.75-7.75V9c0-5.43 2.32-7.75 7.75-7.75h6c5.43 0 7.75 2.32 7.75 7.75v6c0 5.43-2.32 7.75-7.75 7.75m-6-20C4.39 2.75 2.75 4.39 2.75 9v6c0 4.61 1.64 6.25 6.25 6.25h6c4.61 0 6.25-1.64 6.25-6.25V9c0-4.61-1.64-6.25-6.25-6.25z"
      fill={color}
    />
    <path
      d="M21.48 7.86H2.52a.749.749 0 1 1 0-1.5h18.96a.749.749 0 1 1 0 1.5"
      fill={color}
    />
    <path
      d="M8.52 7.72c-.41 0-.75-.34-.75-.75V2.11c0-.41.34-.75.75-.75s.75.34.75.75v4.86c0 .41-.34.75-.75.75m6.96-.45c-.41 0-.75-.34-.75-.75V2.11c0-.41.34-.75.75-.75s.75.34.75.75v4.41c0 .42-.33.75-.75.75m-4.39 10.85c-.36 0-.7-.09-1.01-.26-.68-.4-1.08-1.2-1.08-2.21v-2.4c0-1.01.4-1.82 1.09-2.22s1.59-.34 2.46.17l2.08 1.2c.87.5 1.38 1.25 1.38 2.05S15.5 16 14.62 16.5l-2.08 1.2c-.48.28-.98.42-1.45.42m.01-5.85c-.1 0-.19.02-.26.06-.21.12-.34.46-.34.92v2.4c0 .45.13.79.34.92.21.12.57.06.96-.17l2.08-1.2c.39-.23.63-.51.63-.75s-.23-.52-.63-.75l-2.08-1.2c-.26-.15-.51-.23-.7-.23"
      fill={color}
    />
  </svg>
);

export const MoviesActiveIcon = ({
  color = "#B6B6B6",
  width = 24,
  height = 24,
}: {
  color?: string;
  width?: number;
  height?: number;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.73 2H9.27v4.36h5.46zm1.5 0v4.36h5.64c-.51-2.75-2.54-4.35-5.64-4.36M2 7.86v8.33C2 19.83 4.17 22 7.81 22h8.38c3.64 0 5.81-2.17 5.81-5.81V7.86zm12.44 8.32-2.08 1.2c-.44.25-.87.38-1.27.38-.3 0-.57-.07-.82-.21-.58-.33-.9-1.01-.9-1.89v-2.4c0-.88.32-1.56.9-1.89.58-.34 1.32-.28 2.09.17l2.08 1.2c.77.44 1.19 1.06 1.19 1.73s-.43 1.26-1.19 1.71M7.77 2c-3.1.01-5.13 1.61-5.64 4.36h5.64z"
      fill={color}
    />
  </svg>
);

export const ShowsInactiveIcon = ({
  color = "#B6B6B6",
  width = 24,
  height = 24,
}: {
  color?: string;
  width?: number;
  height?: number;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 22.75H7c-3.65 0-5.75-2.1-5.75-5.75v-5c0-3.65 2.1-5.75 5.75-5.75h10c3.65 0 5.75 2.1 5.75 5.75v5c0 3.65-2.1 5.75-5.75 5.75m-10-15c-2.86 0-4.25 1.39-4.25 4.25v5c0 2.86 1.39 4.25 4.25 4.25h10c2.86 0 4.25-1.39 4.25-4.25v-5c0-2.86-1.39-4.25-4.25-4.25zm11-2.5H6c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h12c.41 0 .75.34.75.75s-.34.75-.75.75m-3-2.5H9c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h6c.41 0 .75.34.75.75s-.34.75-.75.75"
      fill={color}
    />
    <path
      d="M11.09 18.352c-.36 0-.7-.09-1.01-.26-.68-.4-1.08-1.2-1.08-2.21v-2.4c0-1.01.4-1.82 1.09-2.22s1.59-.34 2.46.17l2.08 1.2c.87.5 1.38 1.25 1.38 2.05s-.51 1.55-1.39 2.05l-2.08 1.2c-.48.28-.98.42-1.45.42m.01-5.85c-.1 0-.19.02-.26.06-.21.12-.34.46-.34.92v2.4c0 .45.13.79.34.92.21.12.57.06.96-.17l2.08-1.2c.39-.23.63-.51.63-.75s-.23-.52-.63-.75l-2.08-1.2c-.26-.15-.51-.23-.7-.23"
      fill={color}
    />
  </svg>
);

export const ShowsActiveIcon = ({
  color = "#fff",
  width = 24,
  height = 24,
}: {
  color?: string;
  width?: number;
  height?: number;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 22.75H7c-3.65 0-5.75-2.1-5.75-5.75v-5c0-3.65 2.1-5.75 5.75-5.75h10c3.65 0 5.75 2.1 5.75 5.75v5c0 3.65-2.1 5.75-5.75 5.75m-10-15c-2.86 0-4.25 1.39-4.25 4.25v5c0 2.86 1.39 4.25 4.25 4.25h10c2.86 0 4.25-1.39 4.25-4.25v-5c0-2.86-1.39-4.25-4.25-4.25zm11-2.5H6c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h12c.41 0 .75.34.75.75s-.34.75-.75.75m-3-2.5H9c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h6c.41 0 .75.34.75.75s-.34.75-.75.75"
      fill={color}
    />
    <path
      d="M18 7a4 4 0 0 1 4 4v7a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4v-7a4 4 0 0 1 4-4zm-5.45 4.432c-.87-.51-1.77-.57-2.46-.17S9 12.472 9 13.482v2.4c0 1.01.4 1.81 1.08 2.21.31.17.65.26 1.01.26.47 0 .97-.14 1.45-.42l2.08-1.2c.88-.5 1.39-1.25 1.39-2.05s-.51-1.55-1.38-2.05z"
      fill={color}
    />
  </svg>
);
export const StackIcon = ({ color = "black" }: { color?: string }) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="a"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={20}
      height={20}
    >
      <path fill="#D9D9D9" d="M0 0h20v20H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        d="M5 11.667v1.666H3.333q-.687 0-1.177-.49a1.6 1.6 0 0 1-.49-1.176V3.333q0-.687.49-1.177t1.177-.49h8.334q.687 0 1.177.49t.49 1.177V5h-1.667V3.333H3.333v8.334zm3.333 6.666q-.687 0-1.177-.49a1.6 1.6 0 0 1-.49-1.176V8.333q0-.687.49-1.177t1.177-.49h8.334q.687 0 1.177.49t.49 1.177v8.334q0 .687-.49 1.177t-1.177.49zm0-1.666h8.334V8.333H8.333z"
        fill={color}
      />
    </g>
  </svg>
);
export const MotionPlayIcon = ({ color = "black" }: { color?: string }) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="a"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={20}
      height={20}
    >
      <path fill="#D9D9D9" d="M0 0h20v20H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        d="m8.333 13.333 5-3.333-5-3.333zm1.667 5a8.1 8.1 0 0 1-3.25-.656 8.4 8.4 0 0 1-2.646-1.781 8.4 8.4 0 0 1-1.781-2.646A8.1 8.1 0 0 1 1.667 10q0-.896.187-1.76a9 9 0 0 1 .542-1.678l1.292 1.292a9 9 0 0 0-.26 1.073A6 6 0 0 0 3.332 10q0 2.792 1.938 4.73 1.939 1.935 4.73 1.936t4.73-1.938q1.936-1.937 1.937-4.729 0-2.791-1.938-4.73Q12.792 3.335 10 3.334q-.563 0-1.094.094-.531.095-1.052.26l-1.27-1.27a8.7 8.7 0 0 1 1.666-.563A8 8 0 0 1 10 1.667q1.73 0 3.25.656a8.4 8.4 0 0 1 2.646 1.781 8.4 8.4 0 0 1 1.781 2.646 8.1 8.1 0 0 1 .656 3.25 8.1 8.1 0 0 1-.656 3.25 8.4 8.4 0 0 1-1.781 2.646 8.4 8.4 0 0 1-2.646 1.781 8.1 8.1 0 0 1-3.25.656m-5.417-12.5q-.52 0-.885-.364a1.2 1.2 0 0 1-.365-.886q0-.52.365-.885t.885-.365q.522 0 .886.365.364.364.364.885 0 .522-.364.886a1.2 1.2 0 0 1-.886.364"
        fill={color}
      />
    </g>
  </svg>
);
export const NoteStackIcon = ({ color = "black" }: { color?: string }) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="a"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={20}
      height={20}
    >
      <path fill="#B6B6B6" d="M0 0h20v20H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        d="M5.833 16.666V7.48q0-.688.5-1.167t1.187-.48h9.146q.687 0 1.177.49.49.491.49 1.177v6.667l-4.167 4.167H7.499q-.687 0-1.177-.49a1.6 1.6 0 0 1-.49-1.177M1.687 5.208a1.56 1.56 0 0 1 .27-1.24 1.64 1.64 0 0 1 1.084-.677l9.042-1.604q.687-.125 1.24.27.551.397.676 1.084l.209 1.125h-1.709l-.146-.833-9.02 1.604.833 4.708v5.813a1.9 1.9 0 0 1-.573-.5 1.54 1.54 0 0 1-.302-.709zm5.812 2.291v9.167h5.834v-3.333h3.333V7.499z"
        fill={color}
      />
    </g>
  </svg>
);
export const PlayFromBeginningIcon = ({
  color = "black",
}: {
  color?: string;
}) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="a"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={20}
      height={20}
    >
      <path fill={color} d="M0 0h20v20H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        d="M10 18.333a7.3 7.3 0 0 1-2.927-.593 7.6 7.6 0 0 1-2.375-1.605 7.6 7.6 0 0 1-1.604-2.375 7.3 7.3 0 0 1-.594-2.927h1.667q0 2.438 1.698 4.136T10 16.667t4.135-1.698q1.698-1.697 1.698-4.136 0-2.437-1.698-4.135T10 5h-.125l1.292 1.292L10 7.5 6.667 4.167 10 .833l1.167 1.209-1.292 1.291H10q1.563 0 2.927.594t2.375 1.604a7.6 7.6 0 0 1 1.604 2.375q.594 1.365.594 2.927a7.3 7.3 0 0 1-.594 2.927 7.6 7.6 0 0 1-1.604 2.375 7.6 7.6 0 0 1-2.375 1.604 7.3 7.3 0 0 1-2.927.594"
        fill={color}
      />
    </g>
  </svg>
);

export const LanguageIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="12"
    viewBox="0 0 13 12"
    fill="none"
  >
    <path
      d="M10.5749 5.99994H9.57485C9.44225 5.99994 9.31507 6.05262 9.2213 6.14639C9.12753 6.24016 9.07485 6.36733 9.07485 6.49994C9.07485 6.63255 9.12753 6.75973 9.2213 6.85349C9.31507 6.94726 9.44225 6.99994 9.57485 6.99994V7.99994H8.98185C9.04092 7.83975 9.0722 7.67066 9.07435 7.49994C9.07434 7.16975 8.96538 6.84879 8.76437 6.58684C8.56335 6.32489 8.28153 6.13658 7.96259 6.05112C7.64365 5.96566 7.30542 5.98782 7.00037 6.11417C6.69531 6.24052 6.44046 6.464 6.27535 6.74994C6.242 6.80683 6.22024 6.86975 6.21131 6.93508C6.20237 7.00041 6.20645 7.06686 6.2233 7.13061C6.24016 7.19436 6.26946 7.25415 6.30951 7.30653C6.34957 7.35891 6.39958 7.40285 6.45669 7.43582C6.5138 7.46879 6.57686 7.49014 6.64225 7.49864C6.70764 7.50714 6.77406 7.50262 6.8377 7.48535C6.90134 7.46807 6.96093 7.43838 7.01304 7.39797C7.06516 7.35757 7.10876 7.30726 7.14135 7.24994C7.18524 7.17393 7.24835 7.11082 7.32436 7.06693C7.40037 7.02305 7.48659 6.99994 7.57435 6.99994C7.70696 6.99994 7.83414 7.05262 7.92791 7.14639C8.02168 7.24016 8.07435 7.36733 8.07435 7.49994C8.07435 7.63255 8.02168 7.75973 7.92791 7.85349C7.83414 7.94726 7.70696 7.99994 7.57435 7.99994C7.44175 7.99994 7.31457 8.05262 7.2208 8.14639C7.12703 8.24016 7.07435 8.36733 7.07435 8.49994C7.07435 8.63255 7.12703 8.75973 7.2208 8.8535C7.31457 8.94726 7.44175 8.99994 7.57435 8.99994C7.70696 8.99994 7.83414 9.05262 7.92791 9.14639C8.02168 9.24016 8.07435 9.36733 8.07435 9.49994C8.07435 9.63255 8.02168 9.75973 7.92791 9.8535C7.83414 9.94726 7.70696 9.99994 7.57435 9.99994C7.48659 9.99994 7.40037 9.97684 7.32436 9.93295C7.24835 9.88907 7.18524 9.82595 7.14135 9.74994C7.10876 9.69262 7.06516 9.64231 7.01304 9.60191C6.96093 9.56151 6.90134 9.53181 6.8377 9.51454C6.77406 9.49726 6.70764 9.49274 6.64225 9.50124C6.57686 9.50974 6.5138 9.53109 6.45669 9.56406C6.39958 9.59703 6.34957 9.64097 6.30951 9.69335C6.26946 9.74573 6.24016 9.80552 6.2233 9.86927C6.20645 9.93302 6.20237 9.99947 6.21131 10.0648C6.22024 10.1301 6.242 10.1931 6.27535 10.2499C6.44046 10.5359 6.69531 10.7594 7.00037 10.8857C7.30542 11.0121 7.64365 11.0342 7.96259 10.9488C8.28153 10.8633 8.56335 10.675 8.76437 10.413C8.96538 10.1511 9.07434 9.83013 9.07435 9.49994C9.0722 9.32923 9.04092 9.16013 8.98185 8.99994H9.57435V10.4999C9.57435 10.6326 9.62703 10.7597 9.7208 10.8535C9.81457 10.9473 9.94175 10.9999 10.0744 10.9999C10.207 10.9999 10.3341 10.9473 10.4279 10.8535C10.5217 10.7597 10.5744 10.6326 10.5744 10.4999V6.99994C10.707 6.99994 10.8341 6.94726 10.9279 6.85349C11.0217 6.75973 11.0744 6.63255 11.0744 6.49994C11.0744 6.36733 11.0217 6.24016 10.9279 6.14639C10.8341 6.05262 10.7075 5.99994 10.5749 5.99994ZM4.58935 5.62144C4.60493 5.68554 4.63303 5.74592 4.67204 5.79911C4.71105 5.8523 4.7602 5.89724 4.81665 5.93136C4.87311 5.96547 4.93576 5.98807 5.00099 5.99786C5.06622 6.00766 5.13274 6.00445 5.19672 5.98842C5.26071 5.97239 5.32089 5.94386 5.3738 5.90447C5.42671 5.86508 5.4713 5.81561 5.50501 5.75891C5.53872 5.70221 5.56087 5.63941 5.5702 5.57411C5.57952 5.50881 5.57584 5.44231 5.55935 5.37844L4.68085 1.86344C4.6194 1.61653 4.47711 1.39728 4.27664 1.24059C4.07617 1.0839 3.82904 0.998779 3.5746 0.998779C3.32016 0.998779 3.07304 1.0839 2.87257 1.24059C2.6721 1.39728 2.52981 1.61653 2.46835 1.86344L1.58935 5.37844C1.57287 5.44231 1.56918 5.50881 1.57851 5.57411C1.58784 5.63941 1.60999 5.70221 1.6437 5.75891C1.67741 5.81561 1.722 5.86508 1.77491 5.90447C1.82782 5.94386 1.888 5.97239 1.95198 5.98842C2.01597 6.00445 2.08249 6.00766 2.14772 5.99786C2.21295 5.98807 2.2756 5.96547 2.33206 5.93136C2.38851 5.89724 2.43766 5.8523 2.47667 5.79911C2.51568 5.74592 2.54378 5.68554 2.55935 5.62144L2.83935 4.49994H4.30935L4.58935 5.62144ZM3.08985 3.49994L3.43835 2.10644C3.44886 2.07875 3.46755 2.0549 3.49193 2.03808C3.51631 2.02126 3.54523 2.01225 3.57485 2.01225C3.60448 2.01225 3.6334 2.02126 3.65778 2.03808C3.68216 2.0549 3.70084 2.07875 3.71135 2.10644L4.05985 3.49994H3.08985ZM7.07485 3.49994H7.57485C7.70746 3.49994 7.83464 3.55262 7.92841 3.64639C8.02218 3.74016 8.07485 3.86733 8.07485 3.99994V4.49994C8.07485 4.63255 8.12753 4.75973 8.2213 4.85349C8.31507 4.94726 8.44225 4.99994 8.57485 4.99994C8.70746 4.99994 8.83464 4.94726 8.92841 4.85349C9.02218 4.75973 9.07485 4.63255 9.07485 4.49994V3.99994C9.07446 3.60224 8.91629 3.22094 8.63508 2.93972C8.35386 2.6585 7.97256 2.50034 7.57485 2.49994H7.07485C6.94225 2.49994 6.81507 2.55262 6.7213 2.64639C6.62753 2.74016 6.57485 2.86733 6.57485 2.99994C6.57485 3.13255 6.62753 3.25973 6.7213 3.35349C6.81507 3.44726 6.94225 3.49994 7.07485 3.49994ZM5.07485 7.99994H4.57485C4.44225 7.99994 4.31507 7.94726 4.2213 7.85349C4.12753 7.75973 4.07485 7.63255 4.07485 7.49994V6.99994C4.07485 6.86733 4.02218 6.74016 3.92841 6.64639C3.83464 6.55262 3.70746 6.49994 3.57485 6.49994C3.44225 6.49994 3.31507 6.55262 3.2213 6.64639C3.12753 6.74016 3.07485 6.86733 3.07485 6.99994V7.49994C3.07525 7.89764 3.23341 8.27894 3.51463 8.56016C3.79585 8.84138 4.17715 8.99955 4.57485 8.99994H5.07485C5.20746 8.99994 5.33464 8.94726 5.42841 8.8535C5.52218 8.75973 5.57485 8.63255 5.57485 8.49994C5.57485 8.36733 5.52218 8.24016 5.42841 8.14639C5.33464 8.05262 5.20746 7.99994 5.07485 7.99994Z"
      fill="white"
    />
  </svg>
);

export const UnLikeIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.39 18.49V8.33c0-.4.12-.79.34-1.12l2.73-4.06c.43-.65 1.5-1.11 2.41-.77.98.33 1.63 1.43 1.42 2.41l-.52 3.27c-.04.3.04.57.21.78.17.19.42.31.69.31h4.11c.79 0 1.47.32 1.87.88.38.54.45 1.24.2 1.95l-2.46 7.49c-.31 1.24-1.66 2.25-3 2.25h-3.9c-.67 0-1.61-.23-2.04-.66l-1.28-.99c-.49-.37-.78-.96-.78-1.58M5.21 6.38H4.18C2.63 6.38 2 6.98 2 8.46v10.06c0 1.48.63 2.08 2.18 2.08h1.03c1.55 0 2.18-.6 2.18-2.08V8.46c0-1.48-.63-2.08-2.18-2.08"
        fill="#fff"
      />
    </svg>
  );
};

export const LikeIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.28 22.1h-3.8c-.56 0-1.78-.17-2.43-.82l-3.03-2.34.92-1.19 3.1 2.4c.25.24.88.44 1.44.44h3.8c.9 0 1.87-.72 2.07-1.53l2.42-7.35c.16-.44.13-.84-.08-1.13-.22-.31-.62-.49-1.11-.49h-4c-.52 0-1-.22-1.33-.6-.34-.39-.49-.91-.41-1.45l.5-3.21c.12-.56-.26-1.19-.8-1.37-.49-.18-1.12.08-1.34.4l-4.1 6.1-1.24-.83 4.1-6.1c.63-.94 2.01-1.39 3.09-.98 1.25.41 2.05 1.79 1.77 3.07l-.49 3.15c-.01.07-.01.17.06.25.05.05.12.08.2.08h4c.98 0 1.83.41 2.33 1.12.49.69.59 1.6.27 2.48l-2.39 7.28c-.37 1.45-1.91 2.62-3.52 2.62"
      fill="#fff"
    />
    <path
      d="M5.38 21h-1c-1.85 0-2.75-.87-2.75-2.65v-9.8c0-1.78.9-2.65 2.75-2.65h1c1.85 0 2.75.87 2.75 2.65v9.8c0 1.78-.9 2.65-2.75 2.65m-1-13.6c-1.09 0-1.25.26-1.25 1.15v9.8c0 .89.16 1.15 1.25 1.15h1c1.09 0 1.25-.26 1.25-1.15v-9.8c0-.89-.16-1.15-1.25-1.15z"
      fill="#fff"
    />
  </svg>
);

export const MoreIcon = ({
  width = 24,
  height = 24,
  color = "#fff",
}: {
  width?: number;
  height?: number;
  color?: string;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="a"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width="24"
      height="24"
    >
      <path fill="#d9d9d9" d="M0 0h24v24H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        d="M6 14q-.824 0-1.412-.588A1.93 1.93 0 0 1 4 12q0-.825.588-1.412A1.93 1.93 0 0 1 6 10q.824 0 1.412.588Q8 11.175 8 12t-.588 1.412A1.93 1.93 0 0 1 6 14m6 0q-.825 0-1.412-.588A1.93 1.93 0 0 1 10 12q0-.825.588-1.412A1.93 1.93 0 0 1 12 10q.825 0 1.412.588Q14 11.175 14 12t-.588 1.412A1.93 1.93 0 0 1 12 14m6 0q-.824 0-1.413-.588A1.93 1.93 0 0 1 16 12q0-.825.587-1.412A1.93 1.93 0 0 1 18 10q.824 0 1.413.588Q20 11.175 20 12t-.587 1.412A1.93 1.93 0 0 1 18 14"
        fill={"#fff"}
      />
    </g>
  </svg>
);

export const EditIcon = ({
  width = 40,
  height = 40,
}: {
  width?: number;
  height?: number;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27.5 6.5a4.243 4.243 0 0 1 6 6L13.25 32.75 5 35l2.25-8.25z"
      fill="#fff"
      stroke="#fff"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const TrashIcon = ({
  width = 40,
  height = 40,
  fillColor = "#313131",
}: {
  width?: number;
  height?: number;
  fillColor?: string;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.75 21h22.5M39 21v19.688c0 1.406-1.286 2.812-2.571 2.812H23.57c-1.284 0-2.57-1.406-2.57-2.812V21m4.5 0v-2.25c0-1.125 1.125-2.25 2.25-2.25h4.5c1.125 0 2.25 1.125 2.25 2.25V21m-7.312 7.594v8.437m5.625-8.437v8.437"
      stroke={fillColor}
      strokeWidth={3}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ShiftOutlineIcon = ({
  fillColor = "#fff",
}: {
  fillColor?: "#fff" | "#000";
}) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 4L4 10h3v6h6v-6h3L10 4z"
      stroke={fillColor}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);

export const ShiftFilledIcon = ({
  fillColor = "#fff",
}: {
  fillColor?: "#fff" | "#000";
}) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10 4L4 10h3v6h6v-6h3L10 4z" fill={fillColor} />
  </svg>
);

export const ShiftLockedIcon = ({
  fillColor = "#fff",
}: {
  fillColor?: "#fff" | "#000";
}) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10 4L4 10h3v6h6v-6h3L10 4z" fill={fillColor} />
    <line
      x1="6"
      y1="19"
      x2="14"
      y2="19"
      stroke={fillColor}
      strokeWidth={2}
      strokeLinecap="round"
    />
  </svg>
);
export function DownArrow({
  width = 8,
  height = 24,
  stroke = "white",
  strokeWidth = 2,
}: {
  width?: number;
  height?: number;
  stroke?: "white" | "grey" | "grey5";
  strokeWidth?: 2 | 4;
}) {
  let strokeColor = "#fff";
  if (stroke === "white") {
    strokeColor = "white";
  } else if (stroke === "grey") {
    strokeColor = "#E1E1E180";
  } else if (stroke === "grey5") {
    strokeColor = "#CACACA";
  }

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 8 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="overflow-visible"
    >
      <path
        d="M1 13L7 7L1 1"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        transform="rotate(90 4 7)"
      />
    </svg>
  );
}

export const PlayIconSharp = ({
  width = 16,
  height = 16,
  type = "light",
}: {
  width?: number;
  height?: number;
  type?: "light" | "dark";
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m4.128 2.446 9.045 5.09a.533.533 0 0 1 0 .928l-9.045 5.09a.532.532 0 0 1-.795-.466V2.912a.533.533 0 0 1 .795-.466"
      fill={type === "light" ? "#fff" : "#000"}
    />
  </svg>
);

export const MicrodramaEpisodeIcon = () => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.913 3.26 9.007 1.52c-.574-.253-1.44-.253-2.014 0L3.087 3.26C2.1 3.7 1.953 4.3 1.953 4.62s.147.92 1.134 1.36l3.906 1.74c.287.127.647.193 1.007.193s.72-.066 1.007-.193l3.906-1.74c.987-.44 1.134-1.04 1.134-1.36s-.14-.92-1.134-1.36"
      fill="#fff"
    />
    <path
      d="M8 11.36c-.253 0-.507-.053-.74-.153l-4.493-2c-.687-.307-1.22-1.127-1.22-1.88a.492.492 0 1 1 .986 0c0 .36.3.826.634.973l4.493 2c.213.093.46.093.673 0l4.494-2c.333-.147.633-.607.633-.973a.492.492 0 1 1 .987 0c0 .746-.534 1.573-1.22 1.88l-4.494 2c-.226.1-.48.153-.733.153"
      fill="#fff"
    />
    <path
      d="M8 14.667c-.253 0-.507-.054-.74-.154l-4.493-2a2.06 2.06 0 0 1-1.22-1.88.492.492 0 1 1 .986 0c0 .42.247.8.634.974l4.493 2c.213.093.46.093.673 0l4.494-2a1.07 1.07 0 0 0 .633-.974.492.492 0 1 1 .987 0c0 .814-.48 1.547-1.22 1.88l-4.494 2c-.226.1-.48.154-.733.154"
      fill="#fff"
    />
  </svg>
);

export const MicrodramaPlayIcon = () => (
  <svg
    width="42"
    height="42"
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="42" height="42" rx="21" fill="#000" fillOpacity="0.8" />
    <path
      d="M29.938 20.604a1 1 0 0 1-.03 1.628l-12.593 8.632a1 1 0 0 1-1.565-.825V12.052a1 1 0 0 1 1.596-.802z"
      fill="#fff"
    />
  </svg>
);

export const MicrodramaPauseIcon = () => (
  <svg
    width="42"
    height="42"
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="42" height="42" rx="21" fill="#000" fillOpacity="0.8" />
    <path
      d="M14.748 10.275h4.48v19.6h-4.48zm8.96 0h4.48v19.6h-4.48z"
      fill="#fff"
    />
  </svg>
);

export const ArrowUpIcon = ({
  width = 16,
  height = 16,
}: {
  width?: number;
  height?: number;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.78 10.06a.5.5 0 0 1-.147.353.503.503 0 0 1-.706 0L8.58 6.067a.82.82 0 0 0-1.16 0l-4.347 4.346a.503.503 0 0 1-.706 0 .503.503 0 0 1 0-.706L6.713 5.36c.34-.34.8-.533 1.287-.533s.947.186 1.287.533l4.346 4.347a.52.52 0 0 1 .147.353"
      fill="#fff"
    />
  </svg>
);

export const CheckIconBold = () => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.6 8.693 5.867 12.8 14.4 4"
      stroke="#fff"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const OrDividerIcon = ({
  width = 20,
  height = 149,
}: {
  width?: number;
  height?: number;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 149"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.998 79.182q-1.008 0-1.792-.322a3.7 3.7 0 0 1-1.316-.952 4.2 4.2 0 0 1-.812-1.498q-.266-.881-.266-1.988 0-1.624.546-2.688.546-1.078 1.498-1.61.952-.546 2.17-.546.952 0 1.722.322.77.308 1.316.938.56.616.854 1.526.294.896.294 2.044 0 1.12-.28 2.016a4.1 4.1 0 0 1-.826 1.498q-.546.615-1.33.938-.77.322-1.778.322m.028-1.274q.84 0 1.428-.406.588-.405.896-1.162.308-.77.308-1.876 0-1.134-.322-1.932-.308-.798-.91-1.218-.588-.435-1.428-.434-.812 0-1.414.42-.588.405-.91 1.19-.308.784-.308 1.932 0 .84.182 1.498.182.644.518 1.092.337.434.826.672.504.225 1.134.224M11.169 79v-9.24h3.388q.73 0 1.316.112.59.112 1.05.336.463.225.785.56.321.322.476.756.167.42.168.938 0 .49-.154.896a1.9 1.9 0 0 1-.448.7 2.3 2.3 0 0 1-.742.504q-.434.181-1.022.252v.182q.573.07.965.294.393.225.659.63.265.405.448 1.064L18.63 79h-1.666l-.448-1.848q-.14-.56-.42-.896a1.6 1.6 0 0 0-.7-.504 2.9 2.9 0 0 0-.994-.154h-1.708V79zm1.526-4.606h1.75q1.15 0 1.736-.42.602-.42.602-1.288.001-.868-.574-1.274-.56-.42-1.735-.42h-1.779zM10 0l1 59H9zm0 149L9 90h2z"
      fill="#464646"
    />
  </svg>
);

export const LockedIcon2 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 17.35C12.9002 17.35 13.63 16.6202 13.63 15.72C13.63 14.8197 12.9002 14.09 12 14.09C11.0998 14.09 10.37 14.8197 10.37 15.72C10.37 16.6202 11.0998 17.35 12 17.35Z"
      fill="white"
    />
    <path
      d="M18.28 9.53V8.28C18.28 5.58 17.63 2 12 2C6.37 2 5.72 5.58 5.72 8.28V9.53C2.92 9.88 2 11.3 2 14.79V16.65C2 20.75 3.25 22 7.35 22H16.65C20.75 22 22 20.75 22 16.65V14.79C22 11.3 21.08 9.88 18.28 9.53ZM12 18.74C10.33 18.74 8.98 17.38 8.98 15.72C8.98 14.05 10.34 12.7 12 12.7C13.66 12.7 15.02 14.06 15.02 15.72C15.02 17.39 13.67 18.74 12 18.74ZM7.35 9.44C7.27 9.44 7.2 9.44 7.12 9.44V8.28C7.12 5.35 7.95 3.4 12 3.4C16.05 3.4 16.88 5.35 16.88 8.28V9.45C16.8 9.45 16.73 9.45 16.65 9.45H7.35V9.44Z"
      fill="white"
    />
  </svg>
);
export const WhatsAppIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52s.198-.298.298-.497c.099-.198.05-.371-.025-.52s-.669-1.612-.916-2.207c-.242-.579-.487-.5-.669-.51a13 13 0 0 0-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074s2.096 3.2 5.077 4.487c.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413s.248-1.289.173-1.413c-.074-.124-.272-.198-.57-.347z"
      fill="#25d366"
    />
    <path
      d="M12 2C6.477 2 2 6.477 2 12c0 1.89.525 3.66 1.438 5.168L2 22l4.832-1.438A9.96 9.96 0 0 0 12 22c5.523 0 10-4.477 10-10S17.523 2 12 2m0 18a7.97 7.97 0 0 1-4.484-1.375l-3.016.896.896-3.016A7.96 7.96 0 0 1 4 12c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8"
      fill="#25d366"
    />
  </svg>
);

export const HeadingUnderlineVector = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="144"
    height="16"
    viewBox="0 0 144 16"
    fill="none"
  >
    <path
      d="M1.19999 8.77344C61.1315 6.03012 173.063 -9.53142 134.452 14.0434"
      stroke="url(#paint0_linear_10488_27091)"
      strokeWidth="2.4"
      strokeLinecap="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_10488_27091"
        x1="1.40661"
        y1="3.28665"
        x2="131.665"
        y2="8.19285"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#040403" />
        <stop offset="1" stopColor="#EFA73F" />
      </linearGradient>
    </defs>
  </svg>
);

export const StarIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m6.3195 13.793c-0.33333 0-0.56666-0.1133-0.70667-0.22-0.26666-0.1933-0.68-0.6933-0.42-1.8133l0.37999-1.64c0.03333-0.14003-0.04-0.39336-0.14-0.50003l-1.3267-1.3267c-0.7-0.7-0.64-1.3067-0.54667-1.6067s0.4-0.82667 1.3733-0.99333l1.7-0.28c0.12667-0.02 0.33333-0.17333 0.38666-0.28666l0.94-1.88c0.45334-0.90667 1.0533-1.04 1.3733-1.04s0.91999 0.13333 1.3733 1.04l0.94 1.88c0.06 0.11333 0.26 0.26666 0.3867 0.28666l1.7 0.28c0.9733 0.16 1.28 0.69333 1.3733 0.99333 0.0934 0.3 0.1534 0.90667-0.5466 1.6067l-1.3267 1.3267c-0.1 0.1-0.1733 0.36-0.14 0.50003l0.38 1.64c0.26 1.1266-0.1533 1.62-0.42 1.8133s-0.86 0.44-1.86-0.1533l-1.5933-0.9467c-0.13333-0.08-0.41334-0.08-0.54667 0l-1.5933 0.9467c-0.46 0.28-0.84666 0.3733-1.14 0.3733zm3.0133-10.587c-0.10667 0-0.30001 0.12667-0.48 0.48667l-0.94001 1.88c-0.2 0.40667-0.67333 0.75334-1.12 0.82667l-1.7 0.28c-0.38 0.06667-0.55334 0.20667-0.58667 0.31334-0.03334 0.10666 0.02665 0.31999 0.29998 0.59333l1.3267 1.3267c0.34 0.34 0.52 0.96 0.41333 1.4267l-0.38 1.64c-0.11333 0.4733-0.04001 0.7266 0.03332 0.7866 0.07334 0.0534 0.34001 0.0467 0.75334-0.2066l1.6-0.9467c0.44666-0.2667 1.12-0.2667 1.56 0l1.5933 0.9467c0.42 0.2466 0.6867 0.26 0.76 0.2066 0.0734-0.0533 0.1467-0.3066 0.0334-0.7866l-0.38-1.64c-0.1067-0.47336 0.0666-1.0867 0.4133-1.4267l1.3267-1.3267c0.2733-0.27334 0.3333-0.49334 0.3-0.59333-0.0334-0.1-0.2067-0.24667-0.5867-0.31334l-1.7-0.28c-0.4467-0.07333-0.92-0.42-1.12-0.82667l-0.93999-1.88c-0.18-0.36-0.37334-0.48667-0.48-0.48667z"
      fill="#fff"
    />
    <path
      d="m5.334 3.8335h-4c-0.27333 0-0.5-0.22667-0.5-0.5 0-0.27334 0.22667-0.5 0.5-0.5h4c0.27334 0 0.5 0.22666 0.5 0.5 0 0.27333-0.22666 0.5-0.5 0.5z"
      fill="#fff"
    />
    <path
      d="m3.334 13.166h-2c-0.27333 0-0.5-0.2267-0.5-0.5s0.22667-0.5 0.5-0.5h2c0.27334 0 0.5 0.2267 0.5 0.5s-0.22666 0.5-0.5 0.5z"
      fill="#fff"
    />
    <path
      d="m2.0006 8.5h-0.66667c-0.27333 0-0.5-0.22667-0.5-0.5s0.22667-0.5 0.5-0.5h0.66667c0.27333 0 0.5 0.22667 0.5 0.5s-0.22667 0.5-0.5 0.5z"
      fill="#fff"
    />
  </svg>
);

export const HammerArcTrail = ({
  size = 40,
  className,
}: {
  size?: number;
  className?: string;
}) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M 5 35 Q 20 20 35 5"
      stroke="rgba(255, 200, 100, 0.9)"
      strokeWidth="3"
      fill="none"
      strokeLinecap="round"
      className="hammer-crack-arc-fade"
    />
  </svg>
);

export const LockedIcon = ({
  width = 48,
  height = 48,
  "data-testid": dataTestId,
}: {
  width?: number;
  height?: number;
  "data-testid"?: string;
}) => (
  <svg
    data-testid={dataTestId}
    width={width}
    height={height}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x=".25" y=".25" width="47.5" height="47.5" rx="23.75" fill="#000" />
    <rect x=".25" y=".25" width="47.5" height="47.5" rx="23.75" stroke="#fff" />
    <path
      d="M30.445 23.377H17.522c-1.02 0-1.846.826-1.846 1.846v6.462c0 1.02.826 1.846 1.846 1.846h12.923c1.02 0 1.846-.827 1.846-1.846v-6.462c0-1.02-.826-1.846-1.846-1.846Zm-11.078-.001v-3.692a4.615 4.615 0 1 1 9.231 0v3.692"
      stroke="#fff"
    />
  </svg>
);

export const GreenStatusIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="8" cy="8" r="3" fill="url(#paint0_linear_11847_13529)" />
    <g filter="url(#filter0_f_11847_13529)">
      <circle cx="8" cy="8" r="3.5" stroke="url(#paint1_linear_11847_13529)" />
    </g>
    <defs>
      <filter
        id="filter0_f_11847_13529"
        x="0"
        y="0"
        width="16"
        height="16"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="2"
          result="effect1_foregroundBlur_11847_13529"
        />
      </filter>
      <linearGradient
        id="paint0_linear_11847_13529"
        x1="8"
        y1="5"
        x2="8"
        y2="11"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#258D58" />
        <stop offset="1" stopColor="#14FF87" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_11847_13529"
        x1="8"
        y1="4"
        x2="8"
        y2="12"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#258D58" />
        <stop offset="1" stopColor="#14FF87" />
      </linearGradient>
    </defs>
  </svg>
);

export const RedStatusIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_f_11847_14638)">
      <circle cx="8" cy="8" r="3.5" stroke="url(#paint0_linear_11847_14638)" />
    </g>
    <circle
      cx="7.9987"
      cy="8.00065"
      r="2.66667"
      fill="url(#paint1_linear_11847_14638)"
    />
    <defs>
      <filter
        id="filter0_f_11847_14638"
        x="0"
        y="0"
        width="16"
        height="16"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="2"
          result="effect1_foregroundBlur_11847_14638"
        />
      </filter>
      <linearGradient
        id="paint0_linear_11847_14638"
        x1="8"
        y1="4"
        x2="8"
        y2="12"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#951C00" />
        <stop offset="1" stopColor="#E10D37" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_11847_14638"
        x1="7.9987"
        y1="5.33398"
        x2="7.9987"
        y2="10.6673"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#951C00" />
        <stop offset="1" stopColor="#E10D37" />
      </linearGradient>
    </defs>
  </svg>
);

export const NoPaymentRequired = () => (
  <svg
    fill="none"
    className="absolute inset-0 h-full w-full"
    preserveAspectRatio="none"
    viewBox="0 0 375 32"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Left decorative line - extends beyond viewBox */}
    <path d="m0 16h51.5" stroke="url(#d)" strokeOpacity="0.2" />
    {/* Center rounded rectangle */}
    <path
      d="m74.5 0.5h226c8.56 0 15.5 6.9396 15.5 15.5 0 8.5604-6.94 15.5-15.5 15.5h-226c-8.5604 0-15.5-6.9396-15.5-15.5 0-8.5604 6.9396-15.5 15.5-15.5z"
      fill="url(#c)"
      fillOpacity="0.5"
    />
    <path
      d="m74.5 0.5h226c8.56 0 15.5 6.9396 15.5 15.5 0 8.5604-6.94 15.5-15.5 15.5h-226c-8.5604 0-15.5-6.9396-15.5-15.5 0-8.5604 6.9396-15.5 15.5-15.5z"
      stroke="url(#b)"
    />
    {/* Right decorative line - extends beyond viewBox */}
    <path d="m323.5 16h51.5" stroke="url(#a)" strokeOpacity="0.2" />
    <defs>
      <linearGradient
        id="d"
        x2="51.5"
        y1="16"
        y2="16"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#2F151E" />
        <stop offset=".47785" stopColor="white" />
        <stop offset="1" stopColor="#382C2D" />
      </linearGradient>
      <linearGradient
        id="c"
        x1="74.5"
        x2="300.5"
        y1="16"
        y2="16"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#28180A" />
        <stop offset="1" stopColor="#270F08" />
      </linearGradient>
      <linearGradient
        id="b"
        x1="74.5"
        x2="300.5"
        y1="16"
        y2="16"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#261707" />
        <stop offset=".5" stopColor="white" />
        <stop offset="1" stopColor="#261707" />
      </linearGradient>
      <linearGradient
        id="a"
        x1="323.5"
        x2="375"
        y1="16"
        y2="16"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#2F151E" />
        <stop offset=".47785" stopColor="white" />
        <stop offset="1" stopColor="#382C2D" />
      </linearGradient>
    </defs>
  </svg>
);

export const CategoriesActiveIcon = ({
  width = 24,
  height = 24,
  color = "#000",
}: {
  color?: string;
  width?: number;
  height?: number;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6M7 20a3 3 0 1 0 0-6 3 3 0 0 0 0 6m7-6h6v5a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1zM4 4h6v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1z"
      fill={color}
      stroke={color}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CategoriesInactiveIcon = ({
  width = 24,
  height = 24,
  color = "#000",
}: {
  color?: string;
  width?: number;
  height?: number;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6M7 20a3 3 0 1 0 0-6 3 3 0 0 0 0 6m7-6h6v5a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1zM4 4h6v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1z"
      stroke={color}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const EmptyContentIcon = ({
  width = 48,
  height = 48,
  className = "",
}: {
  width?: number;
  height?: number;
  className?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <rect x="2" y="2" width="20" height="20" rx="2" />
    <path d="M7 2v20M17 2v20M2 7h5M2 12h20M2 17h5M17 7h5M17 17h5" />
  </svg>
);

// Category Filter Icons - exported from Figma
export const CategoryFilterMoviesIcon = ({
  width = 24,
  height = 24,
}: {
  width?: number;
  height?: number;
}) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.917 16.25V10H16.25v6.25A3.734 3.734 0 0 0 20 20v-1.667a2.063 2.063 0 0 1-2.083-2.083"
      fill="#3f51b5"
    />
    <path
      d="M10 17.916a7.917 7.917 0 1 0 0-15.833 7.917 7.917 0 0 0 0 15.833"
      fill="#90a4ae"
    />
    <path
      d="M10 10.834a.833.833 0 1 0 0-1.667.833.833 0 0 0 0 1.667"
      fill="#37474f"
    />
    <path
      d="M10 7.917a2.083 2.083 0 1 0 0-4.167 2.083 2.083 0 0 0 0 4.167m0 8.333a2.083 2.083 0 1 0 0-4.167 2.083 2.083 0 0 0 0 4.167m4.167-4.166a2.083 2.083 0 1 0 0-4.167 2.083 2.083 0 0 0 0 4.167m-8.334 0a2.083 2.083 0 1 0 0-4.167 2.083 2.083 0 0 0 0 4.167"
      fill="#253278"
    />
  </svg>
);

export const CategoryFilterShowsIcon = ({
  width = 24,
  height = 24,
}: {
  width?: number;
  height?: number;
}) => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.344 3.347c.534-1.631-1.519-2.531-2.363-1.631-1.097-1.8-3.431-.507-3.431-.507S7.284-.197 5.653 1.097c-.59-.59-2.362-.731-2.306 2.137-1.969.17-1.94 2.925-1.04 3.347L15.3 7.706c1.266-.506 1.744-3.881-.956-4.36"
      fill="#d5c006"
    />
    <path
      d="M6.131 1.35c.14-1.21-2.194-.985-1.828.337-.872.31-.253 1.631.45 1.294.028 1.04 1.772.788 1.519-.31.647.282 1.21-1.462-.14-1.321"
      fill="#fff8d6"
    />
    <path
      d="M5.822 1.716c.253-.45-.59-.956-.647-.14-.506-.422-1.153.759-.253.787-.422.647.675 1.04.872.422.872-.085.619-1.21.028-1.069"
      fill="#edd8b4"
    />
    <path
      d="M5.85 2.165c-.338-.084-.281-.112-.253-.365.056-.478-.225-.478-.197-.028.028.28-.028.393-.31.168-.365-.253-.393.028-.056.14.31.142.197.057.197.45 0 .31.169.395.197 0 .028-.393 0-.365.31-.168.309.169.421-.112.112-.197"
      fill="#c9ae81"
    />
    <path
      d="M5.034 4.444c.647-.563-.928-2.081-1.518-.535-1.238-.759-1.829 1.52-.62 2.166.591.337 3.995.112 2.138-1.631"
      fill="#fff8d6"
    />
    <path
      d="M3.74 4.444c-.337-.507-1.35.14-.534.647-1.772.815 3.206 1.406 1.66-.085.393-1.012-.928-1.294-1.125-.562"
      fill="#edd8b4"
    />
    <path
      d="M4.247 4.64c-.281.31-.281.254-.535.113-.478-.31-.646.169-.112.394.31.112.281.169.703.394.338.168.506 0 .084-.225-.421-.225-.393-.17 0-.422.366-.31.113-.563-.14-.253"
      fill="#c9ae81"
    />
    <path
      d="M15.638 5.231c.59-.506-.816-1.856-1.35-.478-1.097-.675-2.054 1.688-.563 1.94-.112 1.013 1.463 1.013 1.463.17 1.012.478 1.659-1.35.45-1.632"
      fill="#fff8d6"
    />
    <path
      d="M14.484 5.231c-.309-.45-1.237.113-.478.563-.675.31.169 1.462.647.59.45.704 1.35-.196.872-.675.31-.871-.872-1.125-1.04-.478"
      fill="#edd8b4"
    />
    <path
      d="M14.934 5.4c-.253.28-.253.225-.478.084-.422-.281-.59-.028-.112.169.28.112.365.197 0 .394-.422.225-.141.393.112.14.281-.281.14-.197.506 0 .31.14.45 0 .085-.197-.366-.197-.366-.168 0-.393.337-.225.112-.479-.113-.197"
      fill="#c9ae81"
    />
    <path
      d="M10.069 1.97c.619-.535-.872-1.941-1.406-.507C7.51.76 6.525 3.207 8.072 3.488c-.112 1.04 1.519 1.069 1.547.169 1.04.506 1.687-1.407.45-1.688"
      fill="#fff8d6"
    />
    <path
      d="M8.86 1.968c-.31-.478-1.266.113-.507.59-.703.31.17 1.52.675.62.45.73 1.407-.197.9-.703.366-.929-.9-1.182-1.068-.507"
      fill="#edd8b4"
    />
    <path
      d="M9.31 2.137c-.282.31-.254.254-.507.113-.45-.281-.619-.028-.112.169.28.112.365.225.028.393-.45.254-.169.422.112.141s.14-.197.535 0c.309.169.478 0 .084-.197-.394-.225-.366-.169 0-.394.338-.253.113-.478-.14-.225"
      fill="#c9ae81"
    />
    <path
      d="M7.762 4.528c.17-.816-1.968-1.125-1.49.45-1.406.112-.816 2.081.815 2.081 2.307-.028 1.885-3.066.675-2.531"
      fill="#fff8d6"
    />
    <path
      d="M6.525 5.288c-.45 2.222 2.784 1.406 1.434-.225-.281-1.013-1.265-.506-1.434.225"
      fill="#edd8b4"
    />
    <path
      d="M7.228 5.118c-.028.422-.337.225-.562.422-.647.563 1.097 1.097 1.378.085.056-.253-.731.028-.59-.394.168-.422-.17-.478-.226-.113"
      fill="#c9ae81"
    />
    <path
      d="M12.74 2.615c.17-.815-1.94-1.097-1.462.45-1.378.113-.647 2.728.788 2.025.562.928 1.912-.028 1.378-.76 1.153-.252.506-2.221-.703-1.715"
      fill="#fff8d6"
    />
    <path
      d="M11.756 3.347c-.562-.197-.956.872-.028.788-.365.675 1.097 1.153.928.112.844.338 1.04-1.012.31-1.097-.31-1.012-1.491-.478-1.21.197"
      fill="#edd8b4"
    />
    <path
      d="M12.263 3.206c-.029.422-.057.366-.338.366-.534.028-.506.337 0 .225.31-.085.45-.057.253.337-.225.478.14.45.197.028s0-.253.422-.31c.365-.055.394-.28-.056-.224s-.394.084-.253-.338c.14-.393-.197-.45-.226-.084"
      fill="#c9ae81"
    />
    <path
      d="m2.194 6.3 2.222 11.138h1.828L4.753 6.3c-.112-1.575-2.784-1.575-2.56 0"
      fill="#f43649"
    />
    <path
      d="m4.753 6.3 1.49 11.138h1.829L7.312 6.3c0-1.575-2.672-1.575-2.559 0"
      fill="#f9f9f9"
    />
    <path
      d="m7.313 6.3.759 11.138H9.9V6.3c.084-1.575-2.588-1.575-2.588 0"
      fill="#f43649"
    />
    <path
      d="M9.9 6.3v11.138h1.8L12.46 6.3c.168-1.575-2.476-1.575-2.56 0"
      fill="#f9f9f9"
    />
    <path
      d="m11.7 17.438 1.153-.788.534-9.984c.17-1.21-.843-1.66-.956-.366z"
      fill="#eb3f3f"
    />
    <path
      d="m13.838 15.975.534-8.943c.197-1.125-.787-1.575-.956-.366l-.535 9.984z"
      fill="#e8e8e8"
    />
    <path
      d="m14.653 15.44.647-8.015c.225-1.04-.731-1.49-.928-.365l-.535 8.943z"
      fill="#eb3f3f"
    />
    <path
      d="m15.188 15.075.647-7.313c.056-.815-.45-1.097-.535-.337l-.647 8.015z"
      fill="#e8e8e8"
    />
  </svg>
);

export const CategoryFilterDramaShortsIcon = ({
  width = 24,
  height = 24,
}: {
  width?: number;
  height?: number;
}) => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#a)">
      <path
        d="M17.923 16c0 1.1-.9 2-2 2h-13c-1.1 0-2-.9-2-2V9.5c0-1.1.9-2 2-2h13c1.1 0 2 .9 2 2z"
        fill="#d5c006"
      />
      <path d="M.922 7.5h17v3h-17z" fill="#3f7123" />
      <path d="M.922 7.5h17V11h-17z" fill="#ccd6dd" />
      <path
        d="M.922 7.5h2l-2 3.5zm5.5 0-2 3.5h3.5l2-3.5zm7 0-2 3.5h3.5l2-3.5z"
        fill="#292f33"
      />
      <path d="M.078 4.104 16.574 0l.845 3.396L.923 7.5z" fill="#ccd6dd" />
      <path
        d="m.078 4.104 2.786 2.913L.923 7.5zm9.579 1.224L6.87 2.414l-3.397.845L6.26 6.173zm6.793-1.69L13.664.724l-3.397.845 2.786 2.913z"
        fill="#292f33"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h18v18H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const CategoryFilterChevronDownIcon = ({
  width = 16,
  height = 16,
  color = "#fff",
}: {
  width?: number;
  height?: number;
  color?: string;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x={0.4}
      y={0.4}
      width={15.2}
      height={15.2}
      rx={7.6}
      stroke={color}
      strokeWidth={0.8}
    />
    <path
      d="m11 6.5-3 3-3-3"
      stroke={color}
      strokeWidth={0.8}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ChevronDownSmallIcon = ({ className }: { className?: string }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M12 16L18 10H6L12 16Z" fill="currentColor" />
  </svg>
);
